// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/contact.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/img-37.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../publicImages/bannerBg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../publicImages/side-bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../publicImages/tick.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../publicImages/footer-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../publicImages/forcompany/for-companies-6-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark_section-pricing-view {
  background: #f2f2f2;
}
.howitworks .card_item {
  border-radius: 10px;
  text-align: center;
  position: relative;
  padding-top: 100px;
}
.home_course .item {
  background-color: #fff;
  flex-grow: inherit;
  flex-basis: auto;
  padding: 15px;
  border-radius: 5px;
}
.home_course .item a {
  background-color: #f0f1f7;
  display: block;
  padding: 15px 0px;
  text-decoration: none;
}
.home_course .item a img {
  width: 70%;
}
.home_course .item a h5 {
  margin-bottom: 0;
  color: #e32726;
  text-transform: uppercase;
  padding-top: 15px;
  font-size: 25px;
  font-weight: 600;
}
.home_course {
  justify-content: space-between;
}
.halftop_img {
  position: absolute;
  transform: translate(-50%, -110%);
  background-color: rgb(255, 255, 255);
  display: inline-block;
  width: 150px;
  height: 150px;
  line-height: 150px;
  left: 50%;
  box-shadow: rgb(203, 226, 239) 0px 2px 5px;
  border-radius: 50%;
}
.howitworks .card_footer {
  background-color: #c7c7c7;
  border-radius: 0 0 10px 10px;
}

.howitworks .card.card_item p {
  font-weight: 400;
  font-size: 17px;
  color: #191818;
  height: 180px;
}
.new-ds-login-home-banner-text {
  height: 350px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.new-ds-login-home-banner-text h1 {
  font-size: 60px;
  font-weight: 600;
  color: #333333;
}

.new-ds-login-home-banner-text h1 span i {
  font-size: 20px;
  color: #cf2e22;
}
.head1 {
  color: #333;
  font-size: 40px;
  text-transform: uppercase;

  font-weight: 600;
}
.new-ds-login-home-banner-text p {
  font-size: 17px;
  color: #333333;
}
section.pricing.pricing-bg {
  background-color: #ffffff !important;
}

section.pricing.pricing-bg h2 {
  font-size: 40px;
  font-weight: 600;
  color: #333333;
}
section.pricing .pricing-views {
  background-color: transparent;
  /* background-image: linear-gradient(180deg,#ffffff 0%,#f1f4f9 100%); */
  background-image: linear-gradient(180deg, #ffffff 0%, #f9f9f9 100%);
  padding-top: 10px;
  padding-bottom: 50px;
}
section.pricing .pricing-views .card {
  box-shadow: none;
  border-radius: 10px;
  border: none;
}
section.pricing .pricing-views .card:hover {
  box-shadow: 0 1px 10px 10px rgba(86, 95, 112, 0.1);
}
section.pricing .pricing-views .card h5 {
  margin: 0px;
  color: #333333;
  background: #f2f2f2;
  padding: 20px 0px;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 0px;
  border-radius: 10px 10px 0px 0px;
}

section.pricing .pricing-views .card-body {
  padding: 0px;
}
section.pricing .pricing-views .card-price {
  color: #333333;
  background: #f2f2f2;
  padding: 10px 0px;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 0px;
}
section.pricing .pricing-views .card-price b {
  font-weight: 600;
  font-size: 45px;
}
section.pricing .pricing-views .row-pricing {
  display: flex;
  justify-content: center;
  width: 100%;
  margin: auto;
  grid-gap: 30px;
}

section.pricing .pricing-views .btn {
  width: auto;
  font-size: 14px;
  display: inline-block;
  text-align: center;
  margin: auto;
  padding: 7px 40px;
  border-radius: 7px;
  letter-spacing: 0.5px;

  margin-top: 10px;
  margin-bottom: 30px;
  font-weight: 500;
  outline: 0px !important;
  box-shadow: none !important;
  color: #fff;
  background-color: #cf2e22 !important;
  border-color: #cf2e22 !important;
  opacity: 1;
}
section.pricing .pricing-views .btn span {
  font-weight: 500;
  font-size: 10px;
  color: #fff8f7;
  text-transform: capitalize;
  display: block;
}
section.pricing .pricing-views .row-pricing .col-lg-4.item.item-first .card {
  box-shadow: none;
  margin-top: 0px;
}
section.pricing .pricing-views .row-pricing ul.side-list-view {
  margin: 0px;
  padding: 0px;
  list-style-type: none;
  background: #f9f9f9;
  border-radius: 10px;
  margin-top: 66px;
  padding-top: 30px;
}
section.pricing .pricing-views .row-pricing ul.side-list-view li {
  margin: 0px;
  padding: 5px 10px;
  /*  */
  font-size: 15px;
  /* font-weight: 400; */
  color: #333333;
  text-align: right;
  font-weight: 600;
  height: 47px;
}
section.pricing .pricing-views ul.fa-ul {
  margin: 0px;
  padding: 0px;
  list-style-type: none;
  padding-top: 30px;
}
section.pricing .pricing-views ul.fa-ul li img {
  width: 25px;
}
section.pricing .pricing-views ul.fa-ul li {
  margin: 0px 20px;
  padding: 10px 15px;
  border-bottom: 1px solid #f3f3f3;
  text-align: center;
  height: 47px;
}
section.pricing .pricing-views ul.fa-ul li:last-child {
  border: 0px;
}
.contact-page-banner {
  height: 420px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / cover no-repeat;
  background-position: 100% 50%;
  margin-top: -15px;
}
.contact-page-banner-layer {
  height: inherit;
  min-height: initial;
  width: 100%;
  position: absolute;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}
.contact-page-banner-text {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  flex-direction: column;
  width: 50%;
  margin: auto;
}
.contact-page-banner-text h1 {
  color: #ffffff;
  font-size: 56px;
  font-weight: bold;
  text-align: center;
}
.contact-page-banner-text p {
  color: #ffffff;
  padding-top: 0.25em;
  padding-bottom: 0.25em;
  font-weight: normal;
  text-align: center;
  font-size: 20px;
}
section.pricing.pricing-another .pricing-views .row-pricing {
  display: flex;
  justify-content: center;
  width: 85%;
  margin: auto;
  grid-gap: 30px;
}
section.pricing.pricing-another .pricing-views ul.fa-ul {
  padding: 0px;
}
section.pricing.pricing-another .pricing-views ul.fa-ul li {
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
section.pricing.pricing-another .pricing-views ul.fa-ul li a {
  margin: 0px;
  padding: 5px 10px;

  font-size: 15px;
  font-weight: 400;
  color: #333333;
}
section.pricing.pricing-another .pricing-views ul.fa-ul li a i {
  color: #018aeb;
}

p.pricing-bottom-btn {
  margin: 0px;
  /* margin-top: -17px; */
  position: relative;
  top: -15px;
}
p.pricing-bottom-btn a {
  font-size: 12px;
  color: #007bff;
  font-weight: 600;
}
.home_course .item a,
.home_course .item {
  background: #ffffff;
}
.home_course .item:hover {
  box-shadow: 0 1px 10px 10px rgba(86, 95, 112, 0.1);
}
.howitworks .card_footer {
  background-color: #f2f2f2;
  border-radius: 0 0 10px 10px;
  box-shadow: 0px 5px 4px #cccccc;
}

.howitworks .card_footer h5 {
  color: #333333;
}
.article-list.contact-feedback {
  padding-bottom: 40px;
}
.article-list.contact-feedback .item {
  padding-top: 50px;
  text-align: center;
}
.article-list.contact-feedback .item .name {
  font-weight: 700;
  font-size: 16px;
  margin-top: 20px;
  color: #e43126;
}
.article-list.contact-feedback .item .description {
  font-size: 14px;
  margin-top: 15px;
  margin-bottom: 0;
  color: #7d8285;
}
.contact-clean {
  padding: 40px 0;
  background-color: #f0f0f0;
}
.contact-clean form {
  max-width: 600px;
  width: 90%;
  margin: 0 auto;
  padding: 40px;
  border-radius: 4px;
  color: #505e6c;
}
.contact-clean h2 {
  margin-top: 5px;
  font-weight: 700;
  font-size: 28px;
  margin-bottom: 36px;
  color: inherit;
}
.contact-clean form .form-control {
  background: #fff;
  border-radius: 2px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.05);
  outline: 0;
  color: inherit;
  padding-left: 12px;
  height: 42px;
}
.contact-clean .form-group:last-child {
  margin-bottom: 5px;
}
.contact-clean form .btn {
  padding: 16px 32px;
  border: none;
  background: 0 0;
  box-shadow: none;
  text-shadow: none;
  opacity: 0.9;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.4px;
  line-height: 1;
  outline: 0 !important;
}
.contact-clean form .btn-primary {
  background-color: #e43126 !important;
  margin-top: 15px;
  color: #fff;
}

.contact-clean form .form-control {
  background: #fff;
  border-radius: 2px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.05);
  outline: 0;
  color: inherit;
  padding-left: 12px;
  height: 42px;
}
.contact-clean form textarea.form-control {
  min-height: 100px;
  max-height: 260px;
  padding-top: 10px;
  resize: vertical;
}
ul.fa-ul li .fa-ul-li-span {
  display: none;
}
.dark_section-pricing-view .iphoneX-view {
  display: flex;
  width: 100%;
  background: #fdfdfd;
  padding: 30px 20px;
  margin: 30px auto;
  border-radius: 40px;
  box-shadow: 0px 5px 4px #cccccc;
  justify-content: center;
  height: 500px;
}
.dark_section-pricing-view .iphoneX-view .item {
  width: 45%;
  text-align: center;
  /* height: 100%; */
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.dark_section-pricing-view .iphoneX-view .item img {
  height: 100%;
}
.dark_section-pricing-view .iphoneX-view .item h1 {
  font-size: 30px;
  color: #333;
  font-weight: 600;

  text-align: center;
}
.dark_section-pricing-view .iphoneX-view .item h2 {
  font-size: 20px;
  text-align: center;
  color: #333;
  color: #1d9d43;
}
.pricing-bottom-box h1 {
  font-size: 30px;
  font-weight: 600;
  color: #333333;
  text-align: center;
  margin-top: 25px;
}
.pricing-bottom-box h3 {
  font-size: 20px;
  font-weight: 400;
  color: #8c8c8c;
  text-align: center;
  margin-bottom: 20px;
}
.pricing-bottom-box .main-view {
  display: flex;
}
.pricing-bottom-box .main-view .item {
  width: 30%;
  padding: 20px;
  border-radius: 10px;
  /* box-shadow: 0px 0px 4px #cccccc; */
  margin-right: 30px;
  background: #ffffff;
  position: relative;
}
.pricing-bottom-box .main-view .item:last-child {
  margin-right: 0px;
}
.pricing-bottom-box .main-view .item img {
  width: 100%;
  border-radius: 10px;
}

.pricing-bottom-box .main-view .item p {
  margin-top: 30px;
  text-align: center;

  font-size: 18px;
  font-size: 22px;
  line-height: 24px;
  color: #333333;
  position: absolute;
  font-weight: 500;
  top: 30%;
  width: 100%;
  left: 0px;
}
.pricing-bottom-box .main-view .item p span {
  font-size: 18px;
  font-size: 22px;
  display: block;
}
.pricing-bottom-box .main-view .item:first-child p {
  top: 27%;
  color: #ffffff;
}
.pricing-bottom-box .main-view .item:last-child p {
  color: #ffffff;
}
p.contactus-more {
  text-align: center;
  margin: 40px 0px 20px 0px;
}
p.contactus-more a {
  color: #007bff;
  font-size: 16px;
  text-transform: capitalize;
}

.dark_section-pricing-view {
  background: #f2f2f2;
}

#contact-us-modal-feedback input.is-invalid + .ant-radio-inner {
  border-color: #dc3545;
}

.focus-input-label .floating-label input.form-control {
  font-size: 15px;
  padding: 10px 10px;
  height: 43px;
  border: none;
  border: solid 1px rgba(0, 0, 0, 0.2);
  min-width: initial;
  box-sizing: border-box;
  -webkit-transition: all 0.3s linear;
  transition: all 0.3s linear;
  color: #000;
  font-weight: 400;
  -webkit-appearance: none;
  width: 100%;

  border-radius: 6px;
  outline: 0px;
  box-shadow: none;
}
.focus-input-label .floating-label {
  position: relative;
  margin-bottom: 18px;
  padding-top: 20px;
}

@media (max-width: 1199px) {
  .pricing-bottom-box .main-view .item p {
    top: 26%;
  }
  .pricing-bottom-box .main-view .item:first-child p {
    top: 22%;
  }
}
@media (max-width: 991px) {
  section.pricing .pricing-views .card h5 {
    font-size: 20px;
  }
  section.pricing .pricing-views .card-price b {
    font-size: 40px;
  }
  section.pricing .pricing-views .row-pricing {
    grid-gap: 15px;
  }
  section.pricing .pricing-views .row-pricing ul.side-list-view li {
    font-size: 12px;
  }
  section.pricing.pricing-bg h2 {
    font-size: 30px;
  }
  .new-ds-login-home-banner-text h1 {
    font-size: 50px;
  }
  .new-ds-login-home-banner-text {
    height: 250px;
  }
  .contact-page-banner {
    height: 320px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / cover no-repeat;
    background-position: 50% 50%;
    margin-top: -15px;
  }
  .contact-page-banner-text {
    width: 80%;
  }
  .contact-page-banner-text h1 {
    font-size: 45px;
  }
  section.pricing.pricing-another .pricing-views .row-pricing {
    width: 100%;
    grid-gap: 15px;
  }
  section.pricing .pricing-views ul.fa-ul li {
    padding: 10px 5px;
    margin: 0px 5px;
  }
  section.pricing.pricing-another .pricing-views ul.fa-ul li a {
    font-size: 13px;
  }
  .pricing-bottom-box .main-view .item p {
    font-size: 17px;
    line-height: 18px;
  }
  .pricing-bottom-box .main-view .item p span {
    font-size: 17px;
    line-height: 18px;
  }
}

@media (max-width: 767px) {
  section.pricing .pricing-views .row-pricing {
    grid-template-columns: repeat(1, 1fr);
  }
  section.pricing .pricing-views .row-pricing ul.side-list-view li {
    text-align: center;
  }
  section.pricing.pricing-another .pricing-views .row-pricing {
    grid-template-columns: repeat(1, 1fr);
  }
  .new-ds-login-home-banner-text h1 {
    font-size: 30px;
  }
  .new-ds-login-home-banner-text p {
    font-size: 13px;
  }
  .new-ds-login-home-banner-text {
    height: 140px;
  }
  .head1 {
    font-size: 25px;
  }
  section.pricing .pricing-views ul.fa-ul li {
    margin: 0px 5px;
    padding: 10px 5px;
  }
  section.pricing.pricing-bg h2 {
    font-size: 25px;
    padding: 15px 25px !important;
  }
  .contact-page-banner-text h1 {
    font-size: 30px;
  }
  .contact-page-banner-text p {
    font-size: 13px;
    font-weight: 600;
  }
  .contact-page-banner {
    height: 210px;
  }
  .contact-clean form {
    padding: 15px;
  }
  section.pricing .pricing-views .row-pricing .col-lg-4.item.item-first {
    display: none;
  }
  ul.fa-ul li .fa-ul-li-span {
    display: inline-block;
    padding-right: 5px;
  }
  .dark_section-pricing-view .iphoneX-view {
    flex-direction: column;
    align-items: center;
    height: auto;
  }
  .dark_section-pricing-view .iphoneX-view .item img {
    width: 100%;
  }
  .dark_section-pricing-view .iphoneX-view .item {
    width: 100%;
    margin-bottom: 30px;
  }
  .pricing-bottom-box .main-view {
    flex-direction: column;
  }
  .pricing-bottom-box .main-view .item {
    width: 100%;
    margin: 0px;
    margin-bottom: 25px;
    text-align: center;
  }
  .pricing-bottom-box .main-view .item:last-child {
    margin-bottom: 0px;
  }
  .pricing-bottom-box .main-view .item img {
    height: auto;
    max-width: 250px;
  }
  section.pricing
    .pricing-views
    .row-pricing
    .col-lg-3.col-md-3.item.item-first {
    display: none;
  }
  .pricing-bottom-box .main-view .item p {
    top: 30%;
    font-size: 21px;
    line-height: 23px;
  }
  .pricing-bottom-box .main-view .item:first-child p {
    top: 27%;
  }
  .pricing-bottom-box .main-view .item p span {
    font-size: 21px;
    line-height: 23px;
  }
}

.cursorDefault {
  cursor: default;
}
.smiliesCss {
  padding-top: 5px;
  width: 80px;
  text-align: center;
}
.smiliesCss.active {
  border: #2a874e 1px solid;
}

.home-top-box-view {
  margin-top: 100px;
}

.data-providers-page header {
  display: flex;
  align-items: center;
  margin-bottom: -75px;
  z-index: 999;
  position: relative;
  background: #fff;
  border-radius: 15px;
  padding: 30px;
}
.data-providers-page header .item {
  width: 50%;
}
.data-providers-page header h1 {
  font-size: 30px;
  color: #1995ff;
  font-weight: 500;
}
.data-providers-page header p {
  font-size: 16px;
  color: #7b7b7b;
  font-weight: 400;
}
.data-providers-page .main-content {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: 50% -227.2px;
  width: 100%;
  position: relative;
  background-color: #ccc;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}
.data-providers-page .main-content h1 {
  font-size: 20px;
  color: #ffffff;
  font-weight: 500;
}
.data-providers-page .main-content p {
  font-size: 15px;
  color: #a2a2a2;
  font-weight: 400;
  margin-bottom: 0px;
}
.data-providers-page .overlay-colored {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1;
}
.data-providers-page .section-content {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 120px 0;
  z-index: 1;
  background-attachment: fixed;
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;
}
.data-providers-page .section-content .item {
  width: 75%;
  margin: auto;
  position: relative;
  margin-bottom: 40px;
}
.data-providers-page .section-content .item::after {
  position: absolute;
  width: 80%;
  background: red;
  height: 2px;
  content: "";
  border: 0;
  height: 1px;
  background: #a2a2a2;
  background-image: -webkit-linear-gradient(left, #1e1e1e, #a2a2a2, #1e1e1e);
  background-image: -moz-linear-gradient(left, #ccc, #333, #ccc);
  background-image: -ms-linear-gradient(left, #ccc, #333, #ccc);
  background-image: -o-linear-gradient(left, #ccc, #333, #ccc);
  width: 80%;
  margin: auto;
  left: 0px;
  right: 0px;
  bottom: -20px;
}
.data-providers-page .section-content .item:last-child::after {
  display: none;
}

@media (max-width: 767px) {
  .data-providers-page header {
    flex-direction: column-reverse;
  }
  .data-providers-page header .item {
    width: 100%;
  }
  .data-providers-page .section-content .item {
    width: 85%;
  }
  .data-providers-page .main-content p {
    /* text-align:justify; */
  }
}

/* =================
    drag and Drop styles
==================== */

.fixed-top nav.navbar a.ant-dropdown-link {
  font-size: 20px;
  margin-right: 20px;
  margin-left: 20px;
  color: #c6c6c6;
  cursor: pointer;
}
a.ant-dropdown-link span.anticon.anticon-down {
  display: none;
}

.ant-dropdown.ant-dropdown-placement-bottomRight {
  min-width: 200px !important;
  --arrow-x: 0 !important;
  --arrow-y: 0px !important;
  right: 0px !important;
  left: auto !important;
}

div.ant-dropdown-placement-bottomRight .ant-dropdown-menu {
  margin-top: 9px;
  border-radius: 0;
  min-width: 200px;
}
div.ant-dropdown-placement-bottomRight .ant-dropdown-menu li {
  margin: 0 !important;
  padding: 0 !important;
}
div.ant-dropdown-placement-bottomRight .ant-dropdown-menu li a {
  font-size: 16px;

  padding: 8px 20px;
  font-weight: 500;
  color: #333333 !important;
  display: block;
}

div.ant-dropdown-placement-bottomRight .ant-dropdown-menu li a:hover {
  background: #000000;
  color: #ffffff !important;
}

.fixed-top nav.navbar div.relonav-nav-custom-dropdown {
  margin: 0;
  padding: 0;
  margin-top: 15px;
  border: 0;
  width: 100%;
  border-radius: 0;
}
.fixed-top nav.navbar div.relonav-nav-custom-dropdown ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.fixed-top nav.navbar div.relonav-nav-custom-dropdown ul li a {
  font-size: 16px;

  padding: 10px 0px;
  padding-left: 30px;
  font-weight: 500;
  color: #333333;
  display: block;
}
.fixed-top nav.navbar div.relonav-nav-custom-dropdown ul li a:hover {
  background: #1dabf5;
  color: #ffffff;
}

.reloHome {
  font-family: "Roboto", sans-serif;
  .dssolonavbar.navbar {
    background: #ffffff;
    border: 0;
    box-shadow: 0px 3px 7px #ebebeb !important;
  }
  .dssolonavbar.navbar .navbar-nav .nav-link:after {
    background: #000000;
  }
  .dssolonavbar.navbar .navbar-nav .nav-link {
    color: #000000;
  }
  .bg-relo {
    background: #f3f3f3;
  }
  .btn {
    background: #d9cafa;
    color: #000000;
    font-weight: 600;
    font-size: 17px;
    font-family: system-ui;
    /* / letter-spacing: 1px; / */
    border-radius: 5px;
    &.btn-2 {
      background: #ffffff;
      border: 1px solid #000000;
    }
  }
  h1 {
    font-size: 40px;
    font-weight: 700;
    span {
      font-size: 40px;
      font-weight: 700;
      display: block;
    }
    margin-bottom: 30px;
  }

  h2 {
    font-size: 33px;
    font-weight: 700;
    margin-bottom: 15px;
  }
  p {
  }

  .bannetTextView {
    min-height: 60vh;
    display: flex;
    flex-direction: column;
    justify-content: end;
    width: 450px;
    padding-bottom: 50px;
  }
  .tials {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 50px;
    width: 95%;
    max-width: 1000px;
    margin: 50px auto;
    &.slider {
      max-width: initial;
      width: auto;
      display: block;
      a {
        color: #000000;
        font-size: 30px;
        justify-content: end;
      }
      p {
        height: 70px;
        overflow: hidden;
      }
      .box {
        height: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .owl-buttons {
        margin-top: 25px;
        button {
          width: 40px;
          height: 40px;
          background: #cccccc;
          border-radius: 50%;
          border: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          color: #333333;
          margin-left: 20px;
          &.owl-prev {
          }
          &.owl-next {
          }
        }
      }
    }
    .active.center {
      transform: scale(1);
      -webkit-filter: grayscale(0); /* Safari 6.0 - 9.0 */
      filter: grayscale(0);

      .box {
        background: #d9cafa;
      }
      p {
        height: 100%;
        overflow: visible;
      }
      .fa-circle-plus:before {
        content: "\\f057";
      }
    }

    .box {
      background: #ffffff;
      padding: 25px;
      border-radius: 10px;
      text-align: left;
      img {
        width: 40px;
        margin-bottom: 20px;
        min-height: 60px;
      }
      h3 {
        font-size: 22px;
        font-weight: 600;
      }
      a {
        padding-top: 20px;
        text-decoration: none;
        display: flex;
        align-items: center;
      }
    }
  }
  @media (max-width: 991px) {
    .dssolonavbar.navbar .navbar-toggler {
      border: 2px solid #000000;
    }
    .dssolonavbar.navbar .navbar-toggler-icon .svg-inline--fa {
      color: #000000;
    }
  }
  @media (max-width: 767px) {
    h1 {
      font-size: 30px;
      span {
        font-size: 30px;
      }
    }
    h2 {
      font-size: 25px;
    }
    .bannetTextView {
      width: 90%;
    }
    .tials {
      grid-template-columns: repeat(1, 1fr);
      max-width: 400px;
    }
    .navbar-brand img {
      width: 100%;
    }
    .navbar-brand span.main-logo-text {
      padding: 0;
    }
  }
}

@media (max-width: 767px) {
  .carousel-inner .carousel-item > div {
    display: none;
  }
  .carousel-inner .carousel-item > div:first-child {
    display: block;
  }
}

.carousel-inner .carousel-item.active,
.carousel-inner .carousel-item-next,
.carousel-inner .carousel-item-prev {
  display: flex;
}

/* / medium and up screens / */
@media (min-width: 768px) {
  .carousel-inner .carousel-item-end.active,
  .carousel-inner .carousel-item-next {
    transform: translateX(25%);
  }

  .carousel-inner .carousel-item-start.active,
  .carousel-inner .carousel-item-prev {
    transform: translateX(-25%);
  }
}

.carousel-inner .carousel-item-end,
.carousel-inner .carousel-item-start {
  transform: translateX(0);
}

/* adapted from  https://codepen.io/glebkema/pen/Xjryjd*/

.owl-item > div:after {
  font-family: sans-serif;
  font-size: 24px;
  font-weight: bold;
}

#NonTAModalMovingTips {
  .modal-body {
    .tails-row {
      column-count: 2;
      display: block;
    }
  }
  @media (max-width: 991px) {
    .modal-body {
      .tails-row {
        column-count: 1;
      }
    }
  }
}

#NonTAPackingRecommendations {
  .tails-row {
    column-count: 2;
    display: block;
    .tails {
      margin-bottom: 30px;
      page-break-inside: avoid;
    }
  }

  @media (max-width: 991px) {
    .tails-row {
      column-count: 1;
    }
  }
}

.new-r-n-h {
  font-family: "Cabinet Grotesk";
  background: rgba(246, 246, 246, 1);
  padding-top: 25px;
  .navbar li {
    position: relative;
  }
  .navbar .nav-link {
    padding-right: 25px !important;
    padding-left: 25px !important;
  }
  .navbar li.parent:before {
    content: "\\f107";
    z-index: 200;
    position: absolute;
    top: 50%;
    right: 5px;
    transition: margin-top 0.1s ease-out;
    font-family: "Font Awesome 6 Pro";
    color: #ffffff;
    transform: translatey(-40%);
  }

  .navbar li:hover .children,
  .navbar li:focus .children {
    opacity: 1;
    transform: rotateX(0) translateZ(0);
  }
  .navbar .children {
    opacity: 0;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    transform: rotateX(-90deg);
    transform-style: preserve-3d;
    transform-origin: top center;
    transition: transform 0.4s cubic-bezier(0.17, 0.67, 0.59, 1.21),
      opacity 0.1s 0.1s;
    z-index: 100;
    list-style-type: none;
    position: absolute;
    top: 100%;
    left: 0;
    width: 200px;
    padding: 15px;
    background-color: #fff;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.1);
    text-align: left;
    margin-top: 8px;
    border-radius: 7px;
  }
  .navbar .children li {
    float: none;
    &:last-child {
      a {
        border: 0;
        margin: 0;
        padding: 0;
      }
    }
  }
  .navbar .children a {
    text-decoration: none;
    color: #333333;
    font-weight: 500;
    border-bottom: 1px solid #ebebeb;
    display: block;
    padding-bottom: 5px;
    margin-bottom: 5px;
  }
  .btn {
    background: #d7c7fa;
    font-size: 15px;
    font-weight: 600;
    padding: 6px 20px;
    border-radius: 5px;
    color: #000000;
    border: 2px solid #d7c7fa;
    border-radius: 40px;
    &:hover {
      background: #000000;
      color: #d7c7fa;
    }
    &.btn-black {
      background: #000000;
      color: #ffffff;
      border-color: #000000;
      &:hover {
        background: #ffffff;
        color: #000000;
      }
    }
  }
  h1 {
    font-size: 50px;
    font-weight: 800;
  }
  h2 {
    font-size: 35px;
    font-weight: 800;
    /* border-color: red; */
    span.h2-span {
      font-size: 25px;
      display: block;
    }
  }
  p {
  }
  form.width {
    width: 200px;
    text-align: right;
  }
  .bannerPart {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat: no-repeat;
    background-size: cover;
    height: 90vh;
    width: 100%;
    padding: 100px 0;

    .view {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 30px;
      .box-1 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
      }

      .box {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: 300px 300px;
        grid-gap: 20px;
        .items {
          border-radius: 8px;
          overflow: hidden;
          img {
            height: 100%;
            object-fit: cover;
          }
        }
        .items:nth-child(1) {
          grid-column: 1;
        }
        .items:nth-child(2) {
          grid-column: 1;
        }
        .items:nth-child(3) {
          grid-column: 2 / span 3;
          grid-row: 1 / span 2;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          img {
            height: auto;
          }
        }
      }
    }
    padding: 50px 0;
  }

  .tials {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 35px;
    margin: 35px auto 50px;
    .box {
      background: #ffffff;
      padding: 40px;
      border-radius: 28px;
      text-align: left;

      img {
        margin-bottom: 20px;
        filter: brightness(0);
      }
      h3 {
        font-size: 22px;
        font-weight: 600;
        /* text-transform: uppercase; */
        margin-bottom: 20px;
      }
    }
  }
  .box-image {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-repeat: no-repeat;
    height: 100%;
    /* width: 100%; */
    min-height: 600px;
    background-size: cover;
    /* background-position: 0px 0; */
  }
  ul#myTab {
    border: 0;
    justify-content: center;
    background: #ffffff;
    box-shadow: 2px 4px 26.5px 0px #0000000d;
    width: 670px;
    margin: auto;
    padding: 15px 0px 15px 0px;
    border-radius: 100px;
    gap: 80px;
    margin-bottom: 35px;
    .nav-link {
      background: transparent !important;
      color: #000000;
      border: 0;
      font-weight: 600;
      font-size: 17px;
      border-radius: 55px;
      padding: 12px 24px;
      &.active {
        background: #d7c7fa !important;
      }
    }
  }
  .grid-box {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 25px;
    padding-bottom: 50px;
    .items {
      h4 {
        position: relative;
        font-size: 40px;
        font-weight: 800;
        span {
          display: block;
          font-size: 16px;
          text-transform: uppercase;
          margin-bottom: 10px;
          font-weight: 500;
        }
      }
      h3 {
        position: relative;
        font-size: 30px;
        font-weight: 800;
        span {
          display: block;
          font-size: 16px;
          font-weight: 500;
          text-transform: uppercase;
          margin-bottom: 10px;
        }
      }
      P {
        position: relative;
        font-size: 18px;
        font-weight: 500;
      }
      .tail {
        border-radius: 28px;
        overflow: hidden;
        position: relative;
        min-height: 450px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 30px;
        background: #000000;
        &.tailHeight {
          min-height: 440px;
        }
        img {
          position: absolute;
          bottom: 0;
          width: 100%;
          left: 0px;
          top: 0px;
          right: 0px;
          height: 100%;
          object-fit: cover;
          &.report {
            width: 100% !important;
            height: auto !important;
            opacity: 0.4 !important;
          }
          &.right {
            right: 0;
            left: auto;
            &.report {
              width: 50% !important;
            }
          }
        }
      }

      &.full {
        .tail {
          img {
            /* position: static; */
            height: 100%;
            width: 100%;
            object-fit: cover;
            opacity: 1;
          }
          height: 100%;
        }
      }

      height: 100%;
    }

    .subTail {
      background: #ffffff;
      border-radius: 28px;
      overflow: hidden;
      padding: 20px;
      min-height: 250px;
      h3 {
        margin-bottom: 5px;
        font-size: 24px;
        font-weight: 800;
        color: #000000;
        text-transform: uppercase;
      }
    }
  }

  #individuals-tab-pane {
    .grid-box {
      .items {
        &.full {
          display: flex;
          flex-direction: column;
        }
        &.widthFull {
          grid-column: 2 / span 3;
          grid-gap: 25px;
          display: grid;
        }
        .fs-7 {
          font-size: 14px !important;
        }

        .boxView {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          grid-gap: 25px;
          .box-tail {
            border-radius: 30px;
            position: relative;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 25px;
            min-height: 170px;
            box-shadow: 2px 0px 26.5px 5px #0000000d;
            color: #ffffff;
            background: #ffffff;
            p {
              font-size: 13px;
            }
            &.full {
              grid-column: 2 / span 3;
              grid-row: 1 / span 2;
              min-height: 300px;

              h2 {
                font-size: 38px;
                padding-right: 20px;
                font-weight: 800;
                position: relative;
                span {
                  display: block;
                  font-size: 16px;
                  font-weight: 500;
                  text-transform: uppercase;
                  margin-bottom: 10px;
                }
              }
              p {
                font-size: 18px;
              }
            }
            img {
              position: absolute;
              top: 0px;
              left: 0px;
              bottom: 0px;
              right: 0px;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            &:nth-child(1) {
              h3 {
                position: absolute;
                font-size: 22px;
                bottom: 15px;
                left: 0px;
                right: 0px;
                text-align: center;
              }
            }

            &:nth-child(3) {
              h3 {
                font-size: 28px;
              }
            }
          }
          &.boxView-2 {
            grid-template-columns: 65% 35%;
            grid-gap: 25px;
            width: calc(100% - 25px);

            .box-tail {
              display: block;

              &.full {
                grid-row: 1 / span 2;
                grid-column: initial;
                display: flex;
              }
              img.static {
                position: static;
                height: auto;
                width: auto;
              }
              h3 {
                font-size: 24px;
              }
              p {
                font-size: 17px;
              }
            }
          }
        }
      }
    }
  }

  #companies-tab-pane {
    .final-box {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 25px;
      .tail {
        border-radius: 28px;
        overflow: hidden;
        position: relative;
        min-height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 30px;
        background: #000000;
        img {
          position: absolute;
          bottom: 0;
          width: 100%;
          left: 0px;
          top: 0px;
          right: 0px;
          height: 100%;
          width: 100%;
          object-fit: cover;
          opacity: 1;
        }
        h3 {
          font-size: 40px;
          font-weight: 800;
          span {
            display: block;
            font-size: 20px;
            font-weight: 500;
            text-transform: uppercase;
            margin-bottom: 10px;
          }
        }
        p {
          font-size: 18px;
          font-weight: 500;
        }
      }
    }
  }

  ul.tickList {
    list-style-type: none;
    padding: 0;
    margin: 0;
    li {
      font-size: 18px;
      background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
      span {
        display: block;
        font-size: 22px;
        font-weight: 700;
      }
      background-repeat: no-repeat;
      background-position: 0 5px;
      padding-left: 45px;
      font-weight: 500;
      padding-bottom: 25px;
    }
    /* display: flex; */
    /* align-items: center; */
  }
  .accrodianView {
    background: #000000;
    border-radius: 10px;
    overflow: hidden;

    .accordion {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      padding: 40px;
      .accordion-button::after {
        display: none;
      }
      .accordion-item {
        background: #000000;
        .accordion-button {
          color: #ffffff;
          background: transparent;
          /* border-color: red; */
          border: 1px solid #cccccc;
          margin-bottom: 0;
          box-shadow: none;
          border-radius: 7px;
        }
        border-color: #3a3a3a;
        border: 0;
        margin-bottom: 15px;
      }
      .accordion-body {
        background: #ffffff;
        text-align: left;
        margin: 15px 0 0;
        border-radius: 7px;
      }
    }
    h5 {
      font-weight: 800;
    }
    p {
      font-weight: 500;
    }
    &.for-companies {
      background: transparent;
      .accordion {
        padding: 20px;
        .accordion-item {
          background: transparent;
          border-bottom: 2px solid #cccccc;
          border-radius: 0;
          margin: 0;
          &:has(.collapse.show) {
            border-color: #000000;
          }
          .accordion-body {
            background: transparent;
            padding: 0;
            margin-left: 55px;
            margin-top: 10px;
            margin-bottom: 20px;
          }
          .accordion-button {
            color: #000000;
            background: transparent;
            border: 0;
            margin-bottom: 0;
            box-shadow: none;
            border-radius: 0;
            padding: 20px 0px 0px 0px;
            font-weight: 700;
            font-size: 23px;
            img {
              margin-right: 20px;
            }
            &.collapsed {
              border-color: #cccccc;
              padding: 20px 0;
            }
          }
        }
      }
    }
  }
  .footer {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-repeat: no-repeat;
    padding-bottom: 100px;
    background-size: 100%;
    min-height: 600px;
    height: 100%;
    position: relative;
    background-color: #000000;
    .spacing {
      height: 200px;
    }
    h4 {
      color: #ffffff;
      margin-bottom: 20px;
    }
    .logo {
      width: 100%;
      max-width: 300px;
    }
    ul {
      list-style-type: none;
      &.social {
        display: flex;
        li {
          margin-right: 20px;
          a {
            opacity: 0.5;
          }
        }
      }
      li {
        a {
          color: rgba(255, 255, 255, 0.5);
          text-decoration: none;
          font-size: 20px;
          margin-bottom: 5px;
          display: block;
        }
      }
      margin: 0;
      padding: 0;
    }
    .gridView {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      text-align: left;
    }
    background-color: #000000;
  }

  div#signUpModal {
    .modal-content {
      background: #f3f3f3;
      h2 {
        font-weight: 800;
        text-align: center;
      }
      p {
        a {
          color: rgba(45, 116, 255, 1);
          text-decoration: none;
          font-weight: 700;
          padding-left: 5px;
        }
        font-size: 22px;
        font-weight: 500;
        text-align: center;
        color: #000000;
      }
      label {
        font-size: 23px;
        color: #000000;
        font-weight: 600;
        &.form-check-label {
          font-size: 18px;
        }
      }
      .form-check + a {
        font-size: 18px;
        font-weight: 600;
        text-decoration: none;
      }
      input.form-control {
        height: 60px;
        padding: 20px;
        font-size: 20px;
        border-radius: 6px;
      }
      form {
        width: 80%;
        margin: auto;
        padding-bottom: 30px;
      }
      .btn {
        height: 50px;
        width: 100%;
        font-size: 20px;
        font-weight: 500;
        /* margin: 20px 0; */
        &.btn-google {
          background: #fff;
          border-radius: 7px;
          border: 1px solid #ccc;
          &:hover {
            background: #000000;
          }
        }
      }
    }
  }
  .contactUs {
    padding-top: 110px;
    height: auto;
    h2 {
      font-size: 70px;
      font-weight: 800;
    }
    ul {
      list-style-type: none;
      padding: 0;
      margin-top: 45px;
      li {
        font-size: 17px;
        margin-bottom: 15px;
        font-weight: 500;
        span {
          display: block;
          font-weight: 800;
          font-size: 18px;
          margin-bottom: 5px;
        }
        ul {
          display: flex;
          margin: 0;
          margin-top: 10px;
          li {
            margin-right: 10px;
            img {
              width: 25px;
            }
          }
        }
      }
    }
    .form {
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0px 0px 10px #cccccc;
      padding: 30px;
      label {
        font-size: 18px;
        font-weight: 600;
      }
      input.form-control {
        height: 46px;
        border-radius: 7px;
        /* font-weight: 500; */
        font-size: 16px;
      }
    }
  }

  .view.bg-imageView {
    background: #0a0a0a;
  }

  .bannerPart.innerPage {
    height: 40vh;
    min-height: 450px;
  }

  .sr-box-tails {
    max-width: 900px;
    margin: auto;
    margin-top: 5rem;
    .items {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 50px;
      margin-bottom: 4rem;
      h3 {
        color: #ffffff;
        font-weight: 800;
        margin-bottom: 10px;
        span {
          display: block;
          font-size: 1.1rem;
          font-weight: 400;
          margin-bottom: 10px;
        }
      }
      p {
        color: #ffffff;
        font-size: 1rem;
        font-weight: 400;
      }
      img {
        max-width: 400px;
        width: 100%;
      }
    }
  }

  .choose-tails.tials {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 45px;
    .box {
      width: 30%;
    }
    h3 {
      font-size: 28px;
    }
  }

  .forsubText {
    grid-template-columns: 45% 65%;
    grid-gap: 50px;
    text-align: left;
  }
  .for-companies-tails {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 30px;
  }
  .for-companies-calendar {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-columns: 40% 60%;
    grid-gap: 30px;

    .box {
      &.textView {
        background: #000000;
        color: #ffffff;
        padding: 50px;
        border-radius: 13px;
      }
      &.imageView {
        position: relative;
        background: #ffffff;
        border-radius: 13px;
        padding: 50px;
        img {
          position: absolute;
          top: 15px;
          left: 0;
          width: 100%;
        }
      }
    }
    p {
      margin-bottom: 30px;
    }
    ul {
      padding: 0;
      li {
        margin-left: 40px;
        list-style-type: disc;
        margin-bottom: 10px;
      }
    }
    &:last-child {
      grid-template-columns: 60% 40%;
      .box {
        &.textView {
          background: #000000;
          color: #ffffff;
          padding: 50px;
          border-radius: 13px;
        }
        &.imageView {
          position: relative;
          background: #ffffff;
          border-radius: 13px;
          padding: 0px;
          overflow: hidden;
          .imgBg {
            background: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
            background-repeat: no-repeat;
            height: 100%;
            padding: 70px;
            display: flex;
            align-items: flex-end;
            padding-bottom: 0;
          }
          img {
            position: static;
          }
        }
      }
    }
  }

  .for-companiesWhyCHoose {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 25px;
    .box {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 25px;
      .item {
        background: #d7d7d7;
        border-radius: 5px;
        padding: 25px;

        img {
          width: 35px;
          margin-bottom: 20px;
        }
        h4 {
          font-weight: 700;
        }
        p {
          font-size: 16px;
          margin: 0;
        }
      }
    }
  }

  .for-companiesImageTextView {
    position: relative;
    text-align: center;
    img {
      max-width: 1000px;
      margin: auto;
    }
    h6 {
      background: #f5f1ff;
      box-shadow: 2px 6px 10px 0px #0000001a;
      width: 450px;
      border-radius: 10px;
      padding: 20px;
      color: #000000;
      position: absolute;
      top: 60px;
      right: 0px;
      &:nth-child(2) {
        right: auto;
        top: 50%;
        transform: translateY(-50%);
      }
      &:nth-child(3) {
        bottom: -40px;
        top: auto;
        left: 40%;
      }
      span {
        display: block;
        position: relative;
        font-weight: 700;
        font-size: 16px;
        padding-left: 16px;
        text-align: left;
        &::after {
          content: "";
          position: absolute;
          left: 0px;
          top: 0px;
          bottom: 0px;
          height: 100%;
          width: 6px;
          background: #9b70fb;
          border-radius: 10px;
        }
      }
    }
  }

  .tials.for-companiesTails {
    .box {
      background: transparent;
      padding: 40px;
      border-radius: 10px;
      text-align: left;

      &.active,
      &:hover {
        background: #ffffff;
        box-shadow: 0px 11px 18.4px 0px #0000001a;
      }
      a {
        font-size: 16px;
        font-weight: 700;
        text-decoration: none;
        color: #000000;
      }
    }
  }
  .relo-activities-section {
    position: relative;
    .card-view {
      .item {
        position: relative;
        padding: 25px;
        padding-left: 45px;
        margin-bottom: 15px;
        border-radius: 10px;
        max-width: 500px;
        h3 {
          font-size: 20px;
          font-weight: 700;
        }
        p {
          font-size: 16px;
        }
        a {
          color: #9b70fb;
          font-weight: 800;
          text-decoration: none;
          visibility: hidden;
        }
        &.active,
        &:hover {
          background: #f5f1ff;
          box-shadow: 0px 7px 20.9px 0px #0000001a;

          &::after {
            content: "";
            position: absolute;
            left: 20px;
            top: 25px;
            width: 8px;
            bottom: 25px;
            background: #9b70fb;
            border-radius: 10px;
          }
          a {
            visibility: visible;
          }
        }
      }
    }
    .laptop-image {
      position: absolute;
      right: 0px;
      width: 50%;
      top: 0;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .for-companies-slider {
    padding: 50px 80px;
    .vSlider .l-realise-slider-card-block {
      position: relative;
      margin-left: 0px;
      display: flex;
      justify-content: center;
    }

    .vSlider .card {
      position: absolute;
      display: block;
      width: 400px;
      height: auto;
      -webkit-transition: all 0.4s;
      transition: all 0.4s;
      border-radius: 15px;
      box-shadow: 0px 10px 20px #080808;
      background: #f9f9f9;
    }

    .vSlider .card.c {
      -webkit-transform: translate3d(0px, 20px, 0px) scaleX(0.9);
      transform: translate3d(0px, 20px, 0px) scaleX(0.9);
      z-index: 9;
    }

    .vSlider .card.b {
      -webkit-transform: translate3d(0px, 40px, 0px) scaleX(0.8);
      transform: translate3d(0px, 40px, 0px) scaleX(0.8);
      z-index: 1;
    }

    .vSlider .card.a {
      -webkit-transform: translate3d(0px, 0px, 0px) scaleX(1);
      transform: translate3d(0px, 0px, 0px) scaleX(1);
      z-index: 99;
    }

    .vSlider {
      height: 500px;
    }

    /* Basic styling for the slider and cards */
    .vSlider {
      margin: 0px auto 30px;
      width: 100%;
      text-align: center;
    }

    .card {
      display: inline-block;
      width: 200px;
      height: 200px;
      margin: 20px;
      background-color: #f4f4f4;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }


    .card-text {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 32px;
      text-align: left;
    }
    .card-text h4 {
    font-size: 43px;
    font-weight: 800;
    text-transform: uppercase;
    margin-top: 13px;
    }
  p{
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 700;
    color: #000000;
  }
    .card img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    /* Dots styling */
    .slider-dots {
      text-align: center;
      margin-top: 20px;
    }

    .dot {
      display: inline-block;
      width: 25px;
      height: 5px;
      margin: 0 5px;
      background-color: #ddd;
      border-radius: 2px;
      cursor: pointer;
      transition: background-color 0.3s ease;
    }

    .dot.active {
      background-color: #9f77f8;
    }

    .dot:hover {
      background-color: #9f77f8;
    }
  }
  .YourTeamSection {
    position: relative;
    border-radius: 10px;
    overflow: hidden;
    img {
      width: 100%;
    }
    .teamText {
      position: absolute;
      top: 0px;
      bottom: 0;
      left: 0px;
      right: 0px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      max-width: 700px;
      width: 80%;
      margin: auto;
      color: #ffffff;
      text-align: center;
      h4 {
        font-size: 38px;
        font-weight: 700;
      }
    }
  }

  .my-6rem{
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .mt-6rem{
    margin-top: 6rem !important;
  }
  .mb-6rem{
    margin-bottom: 6rem !important;
  }
  .py-6rem{
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  @media (max-width: 1399px) {
    & .grid-box {
      & .items {
        & .tail {
          min-height: 400px;
          &.tailHeight {
            min-height: 400px;
          }
        }
      }
    }
  }

  @media (max-width: 1199px) {
    h1 {
      font-size: 45px;
    }
    & .grid-box {
      & .items {
        h4 {
          font-size: 25px;
        }
        h3 {
          font-size: 22px;
        }
      }
    }

    & .grid-box {
      & .items {
        .tail {
          min-height: 370px;
          &.tailHeight {
            min-height: 334px;
          }
        }
      }
    }
    & #individuals-tab-pane {
      & .grid-box {
        & .items {
          & .boxView {
            & .box-tail {
              padding: 15px;
              p {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
    .navbar .nav-link {
      padding-right: 15px !important;
      padding-left: 10px !important;
    }
    .navbar li.parent:before {
      right: -5px;
    }
    form.width {
      width: 180px;
    }
    .forsubText {
      grid-template-columns: repeat(2, 1fr);
    }
    .for-companies-calendar {
      p {
        font-size: 14px;
        margin-bottom: 15px;
      }
      h3 {
        font-weight: 700;
        font-size: 25px;
      }
      li {
        font-size: 14px;
      }
    }
    .for-companiesImageTextView {
      img {
        max-width: 800px;
        margin: auto;
      }
    }
  } /*1199px - end*/
  @media (max-width: 991px) {
    & .bannerPart {
      height: auto;
      .view {
        grid-template-columns: repeat(1, 1fr);
        .box {
          margin-top: 50px;
        }
      }
    }
    & .grid-box {
      grid-template-columns: repeat(1, 1fr);

      & .items {
        .tail {
          min-height: 350px;
        }

        &.full {
          height: calc(100% - 20px);
        }
      }
    }
    .tials {
      grid-template-columns: repeat(1, 1fr);
    }
    .box-image {
      min-height: 400px;
    }
    form.width {
      text-align: left;
    }
    .contactUs {
      padding-top: 50px;
    }

    & #individuals-tab-pane {
      & .grid-box {
        & .items {
          &.widthFull {
            display: block;
            grid-column: initial;
          }
          & .boxView {
            grid-template-columns: repeat(1, 1fr);
            & .box-tail {
              grid-column: initial !important;
              grid-row: initial !important;
            }
            &.boxView-2 {
              grid-gap: 25px;
              grid-template-columns: repeat(1, 1fr);
              margin-top: 25px;
            }
          }
        }
      }
    }

    & #companies-tab-pane {
      & .final-box {
        grid-template-columns: repeat(1, 1fr);
        & .tail {
          & h3 {
            font-size: 27px;
            span {
              font-size: 18px;
            }
          }
        }
      }
    }

    & ul#myTab {
      gap: 80px;
      width: 100%;
      max-width: 700px;
    }
    .sr-box-tails {
      .items {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 30px;
        flex-direction: column;
        max-width: 400px;
        margin: auto;
        margin-bottom: 35px;
        padding-bottom: 15px;
        border-bottom: 1px solid #3c3c3c;
      }
    }
    .choose-tails.tials {
      gap: 30px;
      .box {
        width: 100%;
      }
    }
    .for-companies-calendar {
      .box {
        &.imageView {
          img {
            position: static;
          }
        }
      }
      grid-template-columns: repeat(1, 1fr);
      p {
        font-size: 16px;
        margin-bottom: 20px;
      }
      h3 {
        font-weight: 700;
        font-size: 30px;
      }
      li {
        font-size: 16px;
      }
      &:last-child {
        grid-template-columns: repeat(1, 1fr);
      }
    }
    .for-companiesImageTextView {
      img {
        max-width: 600px;
        margin: auto;
      }
      h6 {
        width: 300px;
        span {
          font-size: 11px;
        }
      }
    }
    .relo-activities-section {
      .laptop-image {
          position: static;
          width: 100%;
      }
    }
    .YourTeamSection {
      img {
          width: auto;
          height: 300px;
      }
    }
  } /*991px-end*/
  @media (max-width: 767px) {
    h1 {
      font-size: 35px;
    }
    h2 {
      font-size: 28px;
      span.h2-span {
        font-size: 20px;
      }
    }

    .view.bg-imageView {
      position: relative;
      .box-item {
        background: rgba(0, 0, 0, 0.4);
        position: relative;
        z-index: 9;
      }
      /* z-index: 9; */
      min-height: 400px;
      width: 100%;
      margin: auto;
    }
    .box-image {
      position: absolute;
    }
    ul#myTab {
      flex-wrap: nowrap;
      gap: 30px;
      .nav-link {
        font-size: 16px;
      }
    }
    & div#signUpModal {
      & .modal-content {
        form {
          width: 100%;
        }
        padding: 15px !important;
      }
    }
    .for-companiesImageTextView {
      h6 {
        width: 300px;
        top: 0;
      }
    }
    .for-companies-slider {
      padding: 50px;
      .vSlider {
          margin: auto;
          width: 100%;

      }
      .vSlider .card{
        margin: auto;
        width: 100%;
      }
    }
    .YourTeamSection {
      .teamText{
        h4{
          font-size: 28px;
         }
      }
      
    }
  }/*767px-end*/
  @media (max-width: 576px) {
    ul#myTab {
      gap: 20px;
      flex-direction: column;
      margin: auto;
      justify-content: center;
      align-items: center;
      border-radius: 30px;
      padding: 20px;
      margin-bottom: 25px;

      li {
        width: 100%;
      }
      .nav-link {
        font-size: 16px;
        width: 100%;
      }
    }
    .for-companiesWhyCHoose {
      max-width: 350px;
      margin: auto;
      .box {
        grid-template-columns: repeat(1, 1fr);
      }
    }
    .for-companiesImageTextView {
      h6 {
        position: static;
        transform: initial !important;
        width: 100%;
      }
    }
  
  }

  @media (max-width: 450px){
    .for-companies-slider {
      .vSlider {
         height: 400px;

      }
    
    }
     .for-companies-slider {
      .card-text{
        padding: 20px;
        h4 {
          font-size: 30px;
          font-weight: 800;
          margin: 0;
        }
        p{
          font-size: 14px;
        }
      }
    }
  }
}
.city-landing-page.newOne .ulSlider {
  max-width: 730px;
  margin: auto;
  width: 100%;
}

.demoView {
  position: relative;
  div#map {
    height: 100vh;
    width: 100%;
  }
  .point-tails {
    position: absolute;
    z-index: 9;
    top: 30px;
    left: 30px;
    background: #fff;
    padding: 25px;
    border-radius: 12px;
    box-shadow: 0px 0px 10px #838383;
    max-height: calc(100vh - 60px);
    overflow: auto;

    h3 {
      font-size: 16px;
      padding-bottom: 10px;
      margin-bottom: 10px;
      border-bottom: 1px solid #d7d7d7;
      color: #000000;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./public/assets/css/styles.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,oCAAoC;EACpC,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;AACf;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;;EAEzB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,uEAAuE;EACvE,mEAAmE;EACnE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kDAAkD;AACpD;AACA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;;EAErB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,oCAAoC;EACpC,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,KAAK;EACL,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,4EAA+D;EAC/D,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,iBAAiB;;EAEjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kDAAkD;AACpD;AACA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;;EAEhB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;;EAElB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,WAAW;EACX,SAAS;AACX;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,QAAQ;EACR,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,sBAAsB;EACtB,mCAAmC;EACnC,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;;EAEX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,4EAA+D;IAC/D,4BAA4B;IAC5B,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,6BAA6B;EAC/B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;;;;IAIE,aAAa;EACf;EACA;IACE,QAAQ;IACR,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,QAAQ;EACV;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yDAA2C;EAC3C,iCAAiC;EACjC,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;EAClC,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,oCAAoC;EACpC,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,4BAA4B;EAC5B,+BAA+B;EAC/B,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,WAAW;EACX,WAAW;EACX,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,0EAA0E;EAC1E,8DAA8D;EAC9D,6DAA6D;EAC7D,4DAA4D;EAC5D,UAAU;EACV,YAAY;EACZ,SAAS;EACT,UAAU;EACV,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;sBAEsB;;AAEtB;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,eAAe;;EAEf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,eAAe;;EAEf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC;IACE,mBAAmB;IACnB,SAAS;IACT,0CAA0C;EAC5C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;IAClB;MACE,mBAAmB;MACnB,yBAAyB;IAC3B;EACF;EACA;IACE,eAAe;IACf,gBAAgB;IAChB;MACE,eAAe;MACf,gBAAgB;MAChB,cAAc;IAChB;IACA,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;EACA;EACA;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB;MACE,kBAAkB;MAClB,WAAW;MACX,cAAc;MACd;QACE,cAAc;QACd,eAAe;QACf,oBAAoB;MACtB;MACA;QACE,YAAY;QACZ,gBAAgB;MAClB;MACA;QACE,aAAa;QACb,aAAa;QACb,sBAAsB;QACtB,uBAAuB;MACzB;MACA;QACE,gBAAgB;QAChB;UACE,WAAW;UACX,YAAY;UACZ,mBAAmB;UACnB,kBAAkB;UAClB,SAAS;UACT,oBAAoB;UACpB,mBAAmB;UACnB,uBAAuB;UACvB,eAAe;UACf,cAAc;UACd,iBAAiB;UACjB;UACA;UACA;UACA;QACF;MACF;IACF;IACA;MACE,mBAAmB;MACnB,4BAA4B,EAAE,qBAAqB;MACnD,oBAAoB;;MAEpB;QACE,mBAAmB;MACrB;MACA;QACE,YAAY;QACZ,iBAAiB;MACnB;MACA;QACE,gBAAgB;MAClB;IACF;;IAEA;MACE,mBAAmB;MACnB,aAAa;MACb,mBAAmB;MACnB,gBAAgB;MAChB;QACE,WAAW;QACX,mBAAmB;QACnB,gBAAgB;MAClB;MACA;QACE,eAAe;QACf,gBAAgB;MAClB;MACA;QACE,iBAAiB;QACjB,qBAAqB;QACrB,aAAa;QACb,mBAAmB;MACrB;IACF;EACF;EACA;IACE;MACE,yBAAyB;IAC3B;IACA;MACE,cAAc;IAChB;EACF;EACA;IACE;MACE,eAAe;MACf;QACE,eAAe;MACjB;IACF;IACA;MACE,eAAe;IACjB;IACA;MACE,UAAU;IACZ;IACA;MACE,qCAAqC;MACrC,gBAAgB;IAClB;IACA;MACE,WAAW;IACb;IACA;MACE,UAAU;IACZ;EACF;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;;;EAGE,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;AACF;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA,wDAAwD;;AAExD;EACE,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE;MACE,eAAe;MACf,cAAc;IAChB;EACF;EACA;IACE;MACE;QACE,eAAe;MACjB;IACF;EACF;AACF;;AAEA;EACE;IACE,eAAe;IACf,cAAc;IACd;MACE,mBAAmB;MACnB,wBAAwB;IAC1B;EACF;;EAEA;IACE;MACE,eAAe;IACjB;EACF;AACF;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,iBAAiB;EACjB;IACE,kBAAkB;EACpB;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,oCAAoC;IACpC,iCAAiC;IACjC,cAAc;IACd,2BAA2B;EAC7B;;EAEA;;IAEE,UAAU;IACV,mCAAmC;EACrC;EACA;IACE,UAAU;IACV,mCAAmC;IACnC,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,4BAA4B;IAC5B;uBACmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,0CAA0C;IAC1C,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,WAAW;IACX;MACE;QACE,SAAS;QACT,SAAS;QACT,UAAU;MACZ;IACF;EACF;EACA;IACE,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,gCAAgC;IAChC,cAAc;IACd,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB;MACE,mBAAmB;MACnB,cAAc;IAChB;IACA;MACE,mBAAmB;MACnB,cAAc;MACd,qBAAqB;MACrB;QACE,mBAAmB;QACnB,cAAc;MAChB;IACF;EACF;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB;MACE,eAAe;MACf,cAAc;IAChB;EACF;EACA;EACA;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,yDAAmD;IACnD,4BAA4B;IAC5B,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,gBAAgB;;IAEhB;MACE,aAAa;MACb,qCAAqC;MACrC,qBAAqB;MACrB;QACE,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,uBAAuB;MACzB;;MAEA;QACE,aAAa;QACb,qCAAqC;QACrC,+BAA+B;QAC/B,cAAc;QACd;UACE,kBAAkB;UAClB,gBAAgB;UAChB;YACE,YAAY;YACZ,iBAAiB;UACnB;QACF;QACA;UACE,cAAc;QAChB;QACA;UACE,cAAc;QAChB;QACA;UACE,uBAAuB;UACvB,oBAAoB;UACpB,aAAa;UACb,mBAAmB;UACnB,uBAAuB;UACvB,sBAAsB;UACtB;YACE,YAAY;UACd;QACF;MACF;IACF;IACA,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,sBAAsB;IACtB;MACE,mBAAmB;MACnB,aAAa;MACb,mBAAmB;MACnB,gBAAgB;;MAEhB;QACE,mBAAmB;QACnB,qBAAqB;MACvB;MACA;QACE,eAAe;QACf,gBAAgB;QAChB,+BAA+B;QAC/B,mBAAmB;MACrB;IACF;EACF;EACA;IACE,yDAAkD;IAClD,4BAA4B;IAC5B,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,gCAAgC;EAClC;EACA;IACE,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,wCAAwC;IACxC,YAAY;IACZ,YAAY;IACZ,0BAA0B;IAC1B,oBAAoB;IACpB,SAAS;IACT,mBAAmB;IACnB;MACE,kCAAkC;MAClC,cAAc;MACd,SAAS;MACT,gBAAgB;MAChB,eAAe;MACf,mBAAmB;MACnB,kBAAkB;MAClB;QACE,8BAA8B;MAChC;IACF;EACF;EACA;IACE,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,oBAAoB;IACpB;MACE;QACE,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB;UACE,cAAc;UACd,eAAe;UACf,yBAAyB;UACzB,mBAAmB;UACnB,gBAAgB;QAClB;MACF;MACA;QACE,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB;UACE,cAAc;UACd,eAAe;UACf,gBAAgB;UAChB,yBAAyB;UACzB,mBAAmB;QACrB;MACF;MACA;QACE,kBAAkB;QAClB,eAAe;QACf,gBAAgB;MAClB;MACA;QACE,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;QAClB,iBAAiB;QACjB,aAAa;QACb,sBAAsB;QACtB,8BAA8B;QAC9B,aAAa;QACb,mBAAmB;QACnB;UACE,iBAAiB;QACnB;QACA;UACE,kBAAkB;UAClB,SAAS;UACT,WAAW;UACX,SAAS;UACT,QAAQ;UACR,UAAU;UACV,YAAY;UACZ,iBAAiB;UACjB;YACE,sBAAsB;YACtB,uBAAuB;YACvB,uBAAuB;UACzB;UACA;YACE,QAAQ;YACR,UAAU;YACV;cACE,qBAAqB;YACvB;UACF;QACF;MACF;;MAEA;QACE;UACE;YACE,sBAAsB;YACtB,YAAY;YACZ,WAAW;YACX,iBAAiB;YACjB,UAAU;UACZ;UACA,YAAY;QACd;MACF;;MAEA,YAAY;IACd;;IAEA;MACE,mBAAmB;MACnB,mBAAmB;MACnB,gBAAgB;MAChB,aAAa;MACb,iBAAiB;MACjB;QACE,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,yBAAyB;MAC3B;IACF;EACF;;EAEA;IACE;MACE;QACE;UACE,aAAa;UACb,sBAAsB;QACxB;QACA;UACE,uBAAuB;UACvB,cAAc;UACd,aAAa;QACf;QACA;UACE,0BAA0B;QAC5B;;QAEA;UACE,aAAa;UACb,qCAAqC;UACrC,cAAc;UACd;YACE,mBAAmB;YACnB,kBAAkB;YAClB,gBAAgB;YAChB,aAAa;YACb,sBAAsB;YACtB,8BAA8B;YAC9B,aAAa;YACb,iBAAiB;YACjB,wCAAwC;YACxC,cAAc;YACd,mBAAmB;YACnB;cACE,eAAe;YACjB;YACA;cACE,uBAAuB;cACvB,oBAAoB;cACpB,iBAAiB;;cAEjB;gBACE,eAAe;gBACf,mBAAmB;gBACnB,gBAAgB;gBAChB,kBAAkB;gBAClB;kBACE,cAAc;kBACd,eAAe;kBACf,gBAAgB;kBAChB,yBAAyB;kBACzB,mBAAmB;gBACrB;cACF;cACA;gBACE,eAAe;cACjB;YACF;YACA;cACE,kBAAkB;cAClB,QAAQ;cACR,SAAS;cACT,WAAW;cACX,UAAU;cACV,WAAW;cACX,YAAY;cACZ,iBAAiB;YACnB;;YAEA;cACE;gBACE,kBAAkB;gBAClB,eAAe;gBACf,YAAY;gBACZ,SAAS;gBACT,UAAU;gBACV,kBAAkB;cACpB;YACF;;YAEA;cACE;gBACE,eAAe;cACjB;YACF;UACF;UACA;YACE,8BAA8B;YAC9B,cAAc;YACd,wBAAwB;;YAExB;cACE,cAAc;;cAEd;gBACE,oBAAoB;gBACpB,oBAAoB;gBACpB,aAAa;cACf;cACA;gBACE,gBAAgB;gBAChB,YAAY;gBACZ,WAAW;cACb;cACA;gBACE,eAAe;cACjB;cACA;gBACE,eAAe;cACjB;YACF;UACF;QACF;MACF;IACF;EACF;;EAEA;IACE;MACE,aAAa;MACb,qCAAqC;MACrC,cAAc;MACd;QACE,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;QAClB,iBAAiB;QACjB,aAAa;QACb,sBAAsB;QACtB,8BAA8B;QAC9B,aAAa;QACb,mBAAmB;QACnB;UACE,kBAAkB;UAClB,SAAS;UACT,WAAW;UACX,SAAS;UACT,QAAQ;UACR,UAAU;UACV,YAAY;UACZ,WAAW;UACX,iBAAiB;UACjB,UAAU;QACZ;QACA;UACE,eAAe;UACf,gBAAgB;UAChB;YACE,cAAc;YACd,eAAe;YACf,gBAAgB;YAChB,yBAAyB;YACzB,mBAAmB;UACrB;QACF;QACA;UACE,eAAe;UACf,gBAAgB;QAClB;MACF;IACF;EACF;;EAEA;IACE,qBAAqB;IACrB,UAAU;IACV,SAAS;IACT;MACE,eAAe;MACf,mDAAyC;MACzC;QACE,cAAc;QACd,eAAe;QACf,gBAAgB;MAClB;MACA,4BAA4B;MAC5B,0BAA0B;MAC1B,kBAAkB;MAClB,gBAAgB;MAChB,oBAAoB;IACtB;IACA,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;;IAEhB;MACE,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,YAAY;MACZ,aAAa;MACb;QACE,aAAa;MACf;MACA;QACE,mBAAmB;QACnB;UACE,cAAc;UACd,uBAAuB;UACvB,uBAAuB;UACvB,yBAAyB;UACzB,gBAAgB;UAChB,gBAAgB;UAChB,kBAAkB;QACpB;QACA,qBAAqB;QACrB,SAAS;QACT,mBAAmB;MACrB;MACA;QACE,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;MACpB;IACF;IACA;MACE,gBAAgB;IAClB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,uBAAuB;MACvB;QACE,aAAa;QACb;UACE,uBAAuB;UACvB,gCAAgC;UAChC,gBAAgB;UAChB,SAAS;UACT;YACE,qBAAqB;UACvB;UACA;YACE,uBAAuB;YACvB,UAAU;YACV,iBAAiB;YACjB,gBAAgB;YAChB,mBAAmB;UACrB;UACA;YACE,cAAc;YACd,uBAAuB;YACvB,SAAS;YACT,gBAAgB;YAChB,gBAAgB;YAChB,gBAAgB;YAChB,yBAAyB;YACzB,gBAAgB;YAChB,eAAe;YACf;cACE,kBAAkB;YACpB;YACA;cACE,qBAAqB;cACrB,eAAe;YACjB;UACF;QACF;MACF;IACF;EACF;EACA;IACE,yDAAoD;IACpD,4BAA4B;IAC5B,qBAAqB;IACrB,qBAAqB;IACrB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB;MACE,aAAa;IACf;IACA;MACE,cAAc;MACd,mBAAmB;IACrB;IACA;MACE,WAAW;MACX,gBAAgB;IAClB;IACA;MACE,qBAAqB;MACrB;QACE,aAAa;QACb;UACE,kBAAkB;UAClB;YACE,YAAY;UACd;QACF;MACF;MACA;QACE;UACE,+BAA+B;UAC/B,qBAAqB;UACrB,eAAe;UACf,kBAAkB;UAClB,cAAc;QAChB;MACF;MACA,SAAS;MACT,UAAU;IACZ;IACA;MACE,aAAa;MACb,qCAAqC;MACrC,gBAAgB;IAClB;IACA,yBAAyB;EAC3B;;EAEA;IACE;MACE,mBAAmB;MACnB;QACE,gBAAgB;QAChB,kBAAkB;MACpB;MACA;QACE;UACE,4BAA4B;UAC5B,qBAAqB;UACrB,gBAAgB;UAChB,iBAAiB;QACnB;QACA,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,cAAc;MAChB;MACA;QACE,eAAe;QACf,cAAc;QACd,gBAAgB;QAChB;UACE,eAAe;QACjB;MACF;MACA;QACE,eAAe;QACf,gBAAgB;QAChB,qBAAqB;MACvB;MACA;QACE,YAAY;QACZ,aAAa;QACb,eAAe;QACf,kBAAkB;MACpB;MACA;QACE,UAAU;QACV,YAAY;QACZ,oBAAoB;MACtB;MACA;QACE,YAAY;QACZ,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB;UACE,gBAAgB;UAChB,kBAAkB;UAClB,sBAAsB;UACtB;YACE,mBAAmB;UACrB;QACF;MACF;IACF;EACF;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ;MACE,eAAe;MACf,gBAAgB;IAClB;IACA;MACE,qBAAqB;MACrB,UAAU;MACV,gBAAgB;MAChB;QACE,eAAe;QACf,mBAAmB;QACnB,gBAAgB;QAChB;UACE,cAAc;UACd,gBAAgB;UAChB,eAAe;UACf,kBAAkB;QACpB;QACA;UACE,aAAa;UACb,SAAS;UACT,gBAAgB;UAChB;YACE,kBAAkB;YAClB;cACE,WAAW;YACb;UACF;QACF;MACF;IACF;IACA;MACE,mBAAmB;MACnB,mBAAmB;MACnB,gCAAgC;MAChC,aAAa;MACb;QACE,eAAe;QACf,gBAAgB;MAClB;MACA;QACE,YAAY;QACZ,kBAAkB;QAClB,sBAAsB;QACtB,eAAe;MACjB;IACF;EACF;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB;MACE,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,SAAS;MACT,mBAAmB;MACnB;QACE,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB;UACE,cAAc;UACd,iBAAiB;UACjB,gBAAgB;UAChB,mBAAmB;QACrB;MACF;MACA;QACE,cAAc;QACd,eAAe;QACf,gBAAgB;MAClB;MACA;QACE,gBAAgB;QAChB,WAAW;MACb;IACF;EACF;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,SAAS;IACT;MACE,UAAU;IACZ;IACA;MACE,eAAe;IACjB;EACF;;EAEA;IACE,8BAA8B;IAC9B,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,qCAAqC;IACrC,cAAc;EAChB;EACA;IACE,aAAa;IACb,qCAAqC;IACrC,8BAA8B;IAC9B,cAAc;;IAEd;MACE;QACE,mBAAmB;QACnB,cAAc;QACd,aAAa;QACb,mBAAmB;MACrB;MACA;QACE,kBAAkB;QAClB,mBAAmB;QACnB,mBAAmB;QACnB,aAAa;QACb;UACE,kBAAkB;UAClB,SAAS;UACT,OAAO;UACP,WAAW;QACb;MACF;IACF;IACA;MACE,mBAAmB;IACrB;IACA;MACE,UAAU;MACV;QACE,iBAAiB;QACjB,qBAAqB;QACrB,mBAAmB;MACrB;IACF;IACA;MACE,8BAA8B;MAC9B;QACE;UACE,mBAAmB;UACnB,cAAc;UACd,aAAa;UACb,mBAAmB;QACrB;QACA;UACE,kBAAkB;UAClB,mBAAmB;UACnB,mBAAmB;UACnB,YAAY;UACZ,gBAAgB;UAChB;YACE,mDAAkE;YAClE,4BAA4B;YAC5B,YAAY;YACZ,aAAa;YACb,aAAa;YACb,qBAAqB;YACrB,iBAAiB;UACnB;UACA;YACE,gBAAgB;UAClB;QACF;MACF;IACF;EACF;;EAEA;IACE,qCAAqC;IACrC,cAAc;IACd;MACE,aAAa;MACb,qCAAqC;MACrC,cAAc;MACd;QACE,mBAAmB;QACnB,kBAAkB;QAClB,aAAa;;QAEb;UACE,WAAW;UACX,mBAAmB;QACrB;QACA;UACE,gBAAgB;QAClB;QACA;UACE,eAAe;UACf,SAAS;QACX;MACF;IACF;EACF;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB;MACE,iBAAiB;MACjB,YAAY;IACd;IACA;MACE,mBAAmB;MACnB,sCAAsC;MACtC,YAAY;MACZ,mBAAmB;MACnB,aAAa;MACb,cAAc;MACd,kBAAkB;MAClB,SAAS;MACT,UAAU;MACV;QACE,WAAW;QACX,QAAQ;QACR,2BAA2B;MAC7B;MACA;QACE,aAAa;QACb,SAAS;QACT,SAAS;MACX;MACA;QACE,cAAc;QACd,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB;UACE,WAAW;UACX,kBAAkB;UAClB,SAAS;UACT,QAAQ;UACR,WAAW;UACX,YAAY;UACZ,UAAU;UACV,mBAAmB;UACnB,mBAAmB;QACrB;MACF;IACF;EACF;;EAEA;IACE;MACE,uBAAuB;MACvB,aAAa;MACb,mBAAmB;MACnB,gBAAgB;;MAEhB;;QAEE,mBAAmB;QACnB,yCAAyC;MAC3C;MACA;QACE,eAAe;QACf,gBAAgB;QAChB,qBAAqB;QACrB,cAAc;MAChB;IACF;EACF;EACA;IACE,kBAAkB;IAClB;MACE;QACE,kBAAkB;QAClB,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB,mBAAmB;QACnB,gBAAgB;QAChB;UACE,eAAe;UACf,gBAAgB;QAClB;QACA;UACE,eAAe;QACjB;QACA;UACE,cAAc;UACd,gBAAgB;UAChB,qBAAqB;UACrB,kBAAkB;QACpB;QACA;;UAEE,mBAAmB;UACnB,wCAAwC;;UAExC;YACE,WAAW;YACX,kBAAkB;YAClB,UAAU;YACV,SAAS;YACT,UAAU;YACV,YAAY;YACZ,mBAAmB;YACnB,mBAAmB;UACrB;UACA;YACE,mBAAmB;UACrB;QACF;MACF;IACF;IACA;MACE,kBAAkB;MAClB,UAAU;MACV,UAAU;MACV,MAAM;MACN,YAAY;MACZ;QACE,WAAW;QACX,YAAY;QACZ,iBAAiB;MACnB;IACF;EACF;;EAEA;IACE,kBAAkB;IAClB;MACE,kBAAkB;MAClB,gBAAgB;MAChB,aAAa;MACb,uBAAuB;IACzB;;IAEA;MACE,kBAAkB;MAClB,cAAc;MACd,YAAY;MACZ,YAAY;MACZ,4BAA4B;MAC5B,oBAAoB;MACpB,mBAAmB;MACnB,iCAAiC;MACjC,mBAAmB;IACrB;;IAEA;MACE,0DAA0D;MAC1D,kDAAkD;MAClD,UAAU;IACZ;;IAEA;MACE,0DAA0D;MAC1D,kDAAkD;MAClD,UAAU;IACZ;;IAEA;MACE,uDAAuD;MACvD,+CAA+C;MAC/C,WAAW;IACb;;IAEA;MACE,aAAa;IACf;;IAEA,2CAA2C;IAC3C;MACE,qBAAqB;MACrB,WAAW;MACX,kBAAkB;IACpB;;IAEA;MACE,qBAAqB;MACrB,YAAY;MACZ,aAAa;MACb,YAAY;MACZ,yBAAyB;MACzB,wCAAwC;IAC1C;;;IAGA;MACE,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,WAAW;MACX,YAAY;MACZ,aAAa;MACb,sBAAsB;MACtB,8BAA8B;MAC9B,aAAa;MACb,gBAAgB;IAClB;IACA;IACA,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB;EACF;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;IACE;MACE,WAAW;MACX,YAAY;MACZ,iBAAiB;IACnB;;IAEA,iBAAiB;IACjB;MACE,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,qBAAqB;MACrB,WAAW;MACX,WAAW;MACX,aAAa;MACb,sBAAsB;MACtB,kBAAkB;MAClB,eAAe;MACf,sCAAsC;IACxC;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;IAC3B;EACF;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB;MACE,WAAW;IACb;IACA;MACE,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,SAAS;MACT,UAAU;MACV,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB;MAChB,UAAU;MACV,YAAY;MACZ,cAAc;MACd,kBAAkB;MAClB;QACE,eAAe;QACf,gBAAgB;MAClB;IACF;EACF;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE;MACE;QACE;UACE,iBAAiB;UACjB;YACE,iBAAiB;UACnB;QACF;MACF;IACF;EACF;;EAEA;IACE;MACE,eAAe;IACjB;IACA;MACE;QACE;UACE,eAAe;QACjB;QACA;UACE,eAAe;QACjB;MACF;IACF;;IAEA;MACE;QACE;UACE,iBAAiB;UACjB;YACE,iBAAiB;UACnB;QACF;MACF;IACF;IACA;MACE;QACE;UACE;YACE;cACE,aAAa;cACb;gBACE,eAAe;cACjB;YACF;UACF;QACF;MACF;IACF;IACA;MACE,8BAA8B;MAC9B,6BAA6B;IAC/B;IACA;MACE,WAAW;IACb;IACA;MACE,YAAY;IACd;IACA;MACE,qCAAqC;IACvC;IACA;MACE;QACE,eAAe;QACf,mBAAmB;MACrB;MACA;QACE,gBAAgB;QAChB,eAAe;MACjB;MACA;QACE,eAAe;MACjB;IACF;IACA;MACE;QACE,gBAAgB;QAChB,YAAY;MACd;IACF;EACF,EAAE,eAAe;EACjB;IACE;MACE,YAAY;MACZ;QACE,qCAAqC;QACrC;UACE,gBAAgB;QAClB;MACF;IACF;IACA;MACE,qCAAqC;;MAErC;QACE;UACE,iBAAiB;QACnB;;QAEA;UACE,yBAAyB;QAC3B;MACF;IACF;IACA;MACE,qCAAqC;IACvC;IACA;MACE,iBAAiB;IACnB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,iBAAiB;IACnB;;IAEA;MACE;QACE;UACE;YACE,cAAc;YACd,oBAAoB;UACtB;UACA;YACE,qCAAqC;YACrC;cACE,+BAA+B;cAC/B,4BAA4B;YAC9B;YACA;cACE,cAAc;cACd,qCAAqC;cACrC,gBAAgB;YAClB;UACF;QACF;MACF;IACF;;IAEA;MACE;QACE,qCAAqC;QACrC;UACE;YACE,eAAe;YACf;cACE,eAAe;YACjB;UACF;QACF;MACF;IACF;;IAEA;MACE,SAAS;MACT,WAAW;MACX,gBAAgB;IAClB;IACA;MACE;QACE,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,SAAS;QACT,sBAAsB;QACtB,gBAAgB;QAChB,YAAY;QACZ,mBAAmB;QACnB,oBAAoB;QACpB,gCAAgC;MAClC;IACF;IACA;MACE,SAAS;MACT;QACE,WAAW;MACb;IACF;IACA;MACE;QACE;UACE;YACE,gBAAgB;UAClB;QACF;MACF;MACA,qCAAqC;MACrC;QACE,eAAe;QACf,mBAAmB;MACrB;MACA;QACE,gBAAgB;QAChB,eAAe;MACjB;MACA;QACE,eAAe;MACjB;MACA;QACE,qCAAqC;MACvC;IACF;IACA;MACE;QACE,gBAAgB;QAChB,YAAY;MACd;MACA;QACE,YAAY;QACZ;UACE,eAAe;QACjB;MACF;IACF;IACA;MACE;UACI,gBAAgB;UAChB,WAAW;MACf;IACF;IACA;MACE;UACI,WAAW;UACX,aAAa;MACjB;IACF;EACF,EAAE,YAAY;EACd;IACE;MACE,eAAe;IACjB;IACA;MACE,eAAe;MACf;QACE,eAAe;MACjB;IACF;;IAEA;MACE,kBAAkB;MAClB;QACE,8BAA8B;QAC9B,kBAAkB;QAClB,UAAU;MACZ;MACA,gBAAgB;MAChB,iBAAiB;MACjB,WAAW;MACX,YAAY;IACd;IACA;MACE,kBAAkB;IACpB;IACA;MACE,iBAAiB;MACjB,SAAS;MACT;QACE,eAAe;MACjB;IACF;IACA;MACE;QACE;UACE,WAAW;QACb;QACA,wBAAwB;MAC1B;IACF;IACA;MACE;QACE,YAAY;QACZ,MAAM;MACR;IACF;IACA;MACE,aAAa;MACb;UACI,YAAY;UACZ,WAAW;;MAEf;MACA;QACE,YAAY;QACZ,WAAW;MACb;IACF;IACA;MACE;QACE;UACE,eAAe;SAChB;MACH;;IAEF;EACF,CAAC,YAAY;EACb;IACE;MACE,SAAS;MACT,sBAAsB;MACtB,YAAY;MACZ,uBAAuB;MACvB,mBAAmB;MACnB,mBAAmB;MACnB,aAAa;MACb,mBAAmB;;MAEnB;QACE,WAAW;MACb;MACA;QACE,eAAe;QACf,WAAW;MACb;IACF;IACA;MACE,gBAAgB;MAChB,YAAY;MACZ;QACE,qCAAqC;MACvC;IACF;IACA;MACE;QACE,gBAAgB;QAChB,6BAA6B;QAC7B,WAAW;MACb;IACF;;EAEF;;EAEA;IACE;MACE;SACG,aAAa;;MAEhB;;IAEF;KACC;MACC;QACE,aAAa;QACb;UACE,eAAe;UACf,gBAAgB;UAChB,SAAS;QACX;QACA;UACE,eAAe;QACjB;MACF;IACF;EACF;AACF;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,8BAA8B;IAC9B,cAAc;;IAEd;MACE,eAAe;MACf,oBAAoB;MACpB,mBAAmB;MACnB,gCAAgC;MAChC,cAAc;IAChB;EACF;AACF","sourcesContent":[".dark_section-pricing-view {\n  background: #f2f2f2;\n}\n.howitworks .card_item {\n  border-radius: 10px;\n  text-align: center;\n  position: relative;\n  padding-top: 100px;\n}\n.home_course .item {\n  background-color: #fff;\n  flex-grow: inherit;\n  flex-basis: auto;\n  padding: 15px;\n  border-radius: 5px;\n}\n.home_course .item a {\n  background-color: #f0f1f7;\n  display: block;\n  padding: 15px 0px;\n  text-decoration: none;\n}\n.home_course .item a img {\n  width: 70%;\n}\n.home_course .item a h5 {\n  margin-bottom: 0;\n  color: #e32726;\n  text-transform: uppercase;\n  padding-top: 15px;\n  font-size: 25px;\n  font-weight: 600;\n}\n.home_course {\n  justify-content: space-between;\n}\n.halftop_img {\n  position: absolute;\n  transform: translate(-50%, -110%);\n  background-color: rgb(255, 255, 255);\n  display: inline-block;\n  width: 150px;\n  height: 150px;\n  line-height: 150px;\n  left: 50%;\n  box-shadow: rgb(203, 226, 239) 0px 2px 5px;\n  border-radius: 50%;\n}\n.howitworks .card_footer {\n  background-color: #c7c7c7;\n  border-radius: 0 0 10px 10px;\n}\n\n.howitworks .card.card_item p {\n  font-weight: 400;\n  font-size: 17px;\n  color: #191818;\n  height: 180px;\n}\n.new-ds-login-home-banner-text {\n  height: 350px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.new-ds-login-home-banner-text h1 {\n  font-size: 60px;\n  font-weight: 600;\n  color: #333333;\n}\n\n.new-ds-login-home-banner-text h1 span i {\n  font-size: 20px;\n  color: #cf2e22;\n}\n.head1 {\n  color: #333;\n  font-size: 40px;\n  text-transform: uppercase;\n\n  font-weight: 600;\n}\n.new-ds-login-home-banner-text p {\n  font-size: 17px;\n  color: #333333;\n}\nsection.pricing.pricing-bg {\n  background-color: #ffffff !important;\n}\n\nsection.pricing.pricing-bg h2 {\n  font-size: 40px;\n  font-weight: 600;\n  color: #333333;\n}\nsection.pricing .pricing-views {\n  background-color: transparent;\n  /* background-image: linear-gradient(180deg,#ffffff 0%,#f1f4f9 100%); */\n  background-image: linear-gradient(180deg, #ffffff 0%, #f9f9f9 100%);\n  padding-top: 10px;\n  padding-bottom: 50px;\n}\nsection.pricing .pricing-views .card {\n  box-shadow: none;\n  border-radius: 10px;\n  border: none;\n}\nsection.pricing .pricing-views .card:hover {\n  box-shadow: 0 1px 10px 10px rgba(86, 95, 112, 0.1);\n}\nsection.pricing .pricing-views .card h5 {\n  margin: 0px;\n  color: #333333;\n  background: #f2f2f2;\n  padding: 20px 0px;\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 0px;\n  border-radius: 10px 10px 0px 0px;\n}\n\nsection.pricing .pricing-views .card-body {\n  padding: 0px;\n}\nsection.pricing .pricing-views .card-price {\n  color: #333333;\n  background: #f2f2f2;\n  padding: 10px 0px;\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 0px;\n}\nsection.pricing .pricing-views .card-price b {\n  font-weight: 600;\n  font-size: 45px;\n}\nsection.pricing .pricing-views .row-pricing {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  margin: auto;\n  grid-gap: 30px;\n}\n\nsection.pricing .pricing-views .btn {\n  width: auto;\n  font-size: 14px;\n  display: inline-block;\n  text-align: center;\n  margin: auto;\n  padding: 7px 40px;\n  border-radius: 7px;\n  letter-spacing: 0.5px;\n\n  margin-top: 10px;\n  margin-bottom: 30px;\n  font-weight: 500;\n  outline: 0px !important;\n  box-shadow: none !important;\n  color: #fff;\n  background-color: #cf2e22 !important;\n  border-color: #cf2e22 !important;\n  opacity: 1;\n}\nsection.pricing .pricing-views .btn span {\n  font-weight: 500;\n  font-size: 10px;\n  color: #fff8f7;\n  text-transform: capitalize;\n  display: block;\n}\nsection.pricing .pricing-views .row-pricing .col-lg-4.item.item-first .card {\n  box-shadow: none;\n  margin-top: 0px;\n}\nsection.pricing .pricing-views .row-pricing ul.side-list-view {\n  margin: 0px;\n  padding: 0px;\n  list-style-type: none;\n  background: #f9f9f9;\n  border-radius: 10px;\n  margin-top: 66px;\n  padding-top: 30px;\n}\nsection.pricing .pricing-views .row-pricing ul.side-list-view li {\n  margin: 0px;\n  padding: 5px 10px;\n  /*  */\n  font-size: 15px;\n  /* font-weight: 400; */\n  color: #333333;\n  text-align: right;\n  font-weight: 600;\n  height: 47px;\n}\nsection.pricing .pricing-views ul.fa-ul {\n  margin: 0px;\n  padding: 0px;\n  list-style-type: none;\n  padding-top: 30px;\n}\nsection.pricing .pricing-views ul.fa-ul li img {\n  width: 25px;\n}\nsection.pricing .pricing-views ul.fa-ul li {\n  margin: 0px 20px;\n  padding: 10px 15px;\n  border-bottom: 1px solid #f3f3f3;\n  text-align: center;\n  height: 47px;\n}\nsection.pricing .pricing-views ul.fa-ul li:last-child {\n  border: 0px;\n}\n.contact-page-banner {\n  height: 420px;\n  background: url(../images/contact.jpg) center / cover no-repeat;\n  background-position: 100% 50%;\n  margin-top: -15px;\n}\n.contact-page-banner-layer {\n  height: inherit;\n  min-height: initial;\n  width: 100%;\n  position: absolute;\n  left: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.contact-page-banner-text {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n  flex-direction: column;\n  width: 50%;\n  margin: auto;\n}\n.contact-page-banner-text h1 {\n  color: #ffffff;\n  font-size: 56px;\n  font-weight: bold;\n  text-align: center;\n}\n.contact-page-banner-text p {\n  color: #ffffff;\n  padding-top: 0.25em;\n  padding-bottom: 0.25em;\n  font-weight: normal;\n  text-align: center;\n  font-size: 20px;\n}\nsection.pricing.pricing-another .pricing-views .row-pricing {\n  display: flex;\n  justify-content: center;\n  width: 85%;\n  margin: auto;\n  grid-gap: 30px;\n}\nsection.pricing.pricing-another .pricing-views ul.fa-ul {\n  padding: 0px;\n}\nsection.pricing.pricing-another .pricing-views ul.fa-ul li {\n  height: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\nsection.pricing.pricing-another .pricing-views ul.fa-ul li a {\n  margin: 0px;\n  padding: 5px 10px;\n\n  font-size: 15px;\n  font-weight: 400;\n  color: #333333;\n}\nsection.pricing.pricing-another .pricing-views ul.fa-ul li a i {\n  color: #018aeb;\n}\n\np.pricing-bottom-btn {\n  margin: 0px;\n  /* margin-top: -17px; */\n  position: relative;\n  top: -15px;\n}\np.pricing-bottom-btn a {\n  font-size: 12px;\n  color: #007bff;\n  font-weight: 600;\n}\n.home_course .item a,\n.home_course .item {\n  background: #ffffff;\n}\n.home_course .item:hover {\n  box-shadow: 0 1px 10px 10px rgba(86, 95, 112, 0.1);\n}\n.howitworks .card_footer {\n  background-color: #f2f2f2;\n  border-radius: 0 0 10px 10px;\n  box-shadow: 0px 5px 4px #cccccc;\n}\n\n.howitworks .card_footer h5 {\n  color: #333333;\n}\n.article-list.contact-feedback {\n  padding-bottom: 40px;\n}\n.article-list.contact-feedback .item {\n  padding-top: 50px;\n  text-align: center;\n}\n.article-list.contact-feedback .item .name {\n  font-weight: 700;\n  font-size: 16px;\n  margin-top: 20px;\n  color: #e43126;\n}\n.article-list.contact-feedback .item .description {\n  font-size: 14px;\n  margin-top: 15px;\n  margin-bottom: 0;\n  color: #7d8285;\n}\n.contact-clean {\n  padding: 40px 0;\n  background-color: #f0f0f0;\n}\n.contact-clean form {\n  max-width: 600px;\n  width: 90%;\n  margin: 0 auto;\n  padding: 40px;\n  border-radius: 4px;\n  color: #505e6c;\n}\n.contact-clean h2 {\n  margin-top: 5px;\n  font-weight: 700;\n  font-size: 28px;\n  margin-bottom: 36px;\n  color: inherit;\n}\n.contact-clean form .form-control {\n  background: #fff;\n  border-radius: 2px;\n  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.05);\n  outline: 0;\n  color: inherit;\n  padding-left: 12px;\n  height: 42px;\n}\n.contact-clean .form-group:last-child {\n  margin-bottom: 5px;\n}\n.contact-clean form .btn {\n  padding: 16px 32px;\n  border: none;\n  background: 0 0;\n  box-shadow: none;\n  text-shadow: none;\n  opacity: 0.9;\n  text-transform: uppercase;\n  font-weight: 700;\n  font-size: 13px;\n  letter-spacing: 0.4px;\n  line-height: 1;\n  outline: 0 !important;\n}\n.contact-clean form .btn-primary {\n  background-color: #e43126 !important;\n  margin-top: 15px;\n  color: #fff;\n}\n\n.contact-clean form .form-control {\n  background: #fff;\n  border-radius: 2px;\n  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.05);\n  outline: 0;\n  color: inherit;\n  padding-left: 12px;\n  height: 42px;\n}\n.contact-clean form textarea.form-control {\n  min-height: 100px;\n  max-height: 260px;\n  padding-top: 10px;\n  resize: vertical;\n}\nul.fa-ul li .fa-ul-li-span {\n  display: none;\n}\n.dark_section-pricing-view .iphoneX-view {\n  display: flex;\n  width: 100%;\n  background: #fdfdfd;\n  padding: 30px 20px;\n  margin: 30px auto;\n  border-radius: 40px;\n  box-shadow: 0px 5px 4px #cccccc;\n  justify-content: center;\n  height: 500px;\n}\n.dark_section-pricing-view .iphoneX-view .item {\n  width: 45%;\n  text-align: center;\n  /* height: 100%; */\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n}\n.dark_section-pricing-view .iphoneX-view .item img {\n  height: 100%;\n}\n.dark_section-pricing-view .iphoneX-view .item h1 {\n  font-size: 30px;\n  color: #333;\n  font-weight: 600;\n\n  text-align: center;\n}\n.dark_section-pricing-view .iphoneX-view .item h2 {\n  font-size: 20px;\n  text-align: center;\n  color: #333;\n  color: #1d9d43;\n}\n.pricing-bottom-box h1 {\n  font-size: 30px;\n  font-weight: 600;\n  color: #333333;\n  text-align: center;\n  margin-top: 25px;\n}\n.pricing-bottom-box h3 {\n  font-size: 20px;\n  font-weight: 400;\n  color: #8c8c8c;\n  text-align: center;\n  margin-bottom: 20px;\n}\n.pricing-bottom-box .main-view {\n  display: flex;\n}\n.pricing-bottom-box .main-view .item {\n  width: 30%;\n  padding: 20px;\n  border-radius: 10px;\n  /* box-shadow: 0px 0px 4px #cccccc; */\n  margin-right: 30px;\n  background: #ffffff;\n  position: relative;\n}\n.pricing-bottom-box .main-view .item:last-child {\n  margin-right: 0px;\n}\n.pricing-bottom-box .main-view .item img {\n  width: 100%;\n  border-radius: 10px;\n}\n\n.pricing-bottom-box .main-view .item p {\n  margin-top: 30px;\n  text-align: center;\n\n  font-size: 18px;\n  font-size: 22px;\n  line-height: 24px;\n  color: #333333;\n  position: absolute;\n  font-weight: 500;\n  top: 30%;\n  width: 100%;\n  left: 0px;\n}\n.pricing-bottom-box .main-view .item p span {\n  font-size: 18px;\n  font-size: 22px;\n  display: block;\n}\n.pricing-bottom-box .main-view .item:first-child p {\n  top: 27%;\n  color: #ffffff;\n}\n.pricing-bottom-box .main-view .item:last-child p {\n  color: #ffffff;\n}\np.contactus-more {\n  text-align: center;\n  margin: 40px 0px 20px 0px;\n}\np.contactus-more a {\n  color: #007bff;\n  font-size: 16px;\n  text-transform: capitalize;\n}\n\n.dark_section-pricing-view {\n  background: #f2f2f2;\n}\n\n#contact-us-modal-feedback input.is-invalid + .ant-radio-inner {\n  border-color: #dc3545;\n}\n\n.focus-input-label .floating-label input.form-control {\n  font-size: 15px;\n  padding: 10px 10px;\n  height: 43px;\n  border: none;\n  border: solid 1px rgba(0, 0, 0, 0.2);\n  min-width: initial;\n  box-sizing: border-box;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  color: #000;\n  font-weight: 400;\n  -webkit-appearance: none;\n  width: 100%;\n\n  border-radius: 6px;\n  outline: 0px;\n  box-shadow: none;\n}\n.focus-input-label .floating-label {\n  position: relative;\n  margin-bottom: 18px;\n  padding-top: 20px;\n}\n\n@media (max-width: 1199px) {\n  .pricing-bottom-box .main-view .item p {\n    top: 26%;\n  }\n  .pricing-bottom-box .main-view .item:first-child p {\n    top: 22%;\n  }\n}\n@media (max-width: 991px) {\n  section.pricing .pricing-views .card h5 {\n    font-size: 20px;\n  }\n  section.pricing .pricing-views .card-price b {\n    font-size: 40px;\n  }\n  section.pricing .pricing-views .row-pricing {\n    grid-gap: 15px;\n  }\n  section.pricing .pricing-views .row-pricing ul.side-list-view li {\n    font-size: 12px;\n  }\n  section.pricing.pricing-bg h2 {\n    font-size: 30px;\n  }\n  .new-ds-login-home-banner-text h1 {\n    font-size: 50px;\n  }\n  .new-ds-login-home-banner-text {\n    height: 250px;\n  }\n  .contact-page-banner {\n    height: 320px;\n    background: url(../images/contact.jpg) center / cover no-repeat;\n    background-position: 50% 50%;\n    margin-top: -15px;\n  }\n  .contact-page-banner-text {\n    width: 80%;\n  }\n  .contact-page-banner-text h1 {\n    font-size: 45px;\n  }\n  section.pricing.pricing-another .pricing-views .row-pricing {\n    width: 100%;\n    grid-gap: 15px;\n  }\n  section.pricing .pricing-views ul.fa-ul li {\n    padding: 10px 5px;\n    margin: 0px 5px;\n  }\n  section.pricing.pricing-another .pricing-views ul.fa-ul li a {\n    font-size: 13px;\n  }\n  .pricing-bottom-box .main-view .item p {\n    font-size: 17px;\n    line-height: 18px;\n  }\n  .pricing-bottom-box .main-view .item p span {\n    font-size: 17px;\n    line-height: 18px;\n  }\n}\n\n@media (max-width: 767px) {\n  section.pricing .pricing-views .row-pricing {\n    grid-template-columns: repeat(1, 1fr);\n  }\n  section.pricing .pricing-views .row-pricing ul.side-list-view li {\n    text-align: center;\n  }\n  section.pricing.pricing-another .pricing-views .row-pricing {\n    grid-template-columns: repeat(1, 1fr);\n  }\n  .new-ds-login-home-banner-text h1 {\n    font-size: 30px;\n  }\n  .new-ds-login-home-banner-text p {\n    font-size: 13px;\n  }\n  .new-ds-login-home-banner-text {\n    height: 140px;\n  }\n  .head1 {\n    font-size: 25px;\n  }\n  section.pricing .pricing-views ul.fa-ul li {\n    margin: 0px 5px;\n    padding: 10px 5px;\n  }\n  section.pricing.pricing-bg h2 {\n    font-size: 25px;\n    padding: 15px 25px !important;\n  }\n  .contact-page-banner-text h1 {\n    font-size: 30px;\n  }\n  .contact-page-banner-text p {\n    font-size: 13px;\n    font-weight: 600;\n  }\n  .contact-page-banner {\n    height: 210px;\n  }\n  .contact-clean form {\n    padding: 15px;\n  }\n  section.pricing .pricing-views .row-pricing .col-lg-4.item.item-first {\n    display: none;\n  }\n  ul.fa-ul li .fa-ul-li-span {\n    display: inline-block;\n    padding-right: 5px;\n  }\n  .dark_section-pricing-view .iphoneX-view {\n    flex-direction: column;\n    align-items: center;\n    height: auto;\n  }\n  .dark_section-pricing-view .iphoneX-view .item img {\n    width: 100%;\n  }\n  .dark_section-pricing-view .iphoneX-view .item {\n    width: 100%;\n    margin-bottom: 30px;\n  }\n  .pricing-bottom-box .main-view {\n    flex-direction: column;\n  }\n  .pricing-bottom-box .main-view .item {\n    width: 100%;\n    margin: 0px;\n    margin-bottom: 25px;\n    text-align: center;\n  }\n  .pricing-bottom-box .main-view .item:last-child {\n    margin-bottom: 0px;\n  }\n  .pricing-bottom-box .main-view .item img {\n    height: auto;\n    max-width: 250px;\n  }\n  section.pricing\n    .pricing-views\n    .row-pricing\n    .col-lg-3.col-md-3.item.item-first {\n    display: none;\n  }\n  .pricing-bottom-box .main-view .item p {\n    top: 30%;\n    font-size: 21px;\n    line-height: 23px;\n  }\n  .pricing-bottom-box .main-view .item:first-child p {\n    top: 27%;\n  }\n  .pricing-bottom-box .main-view .item p span {\n    font-size: 21px;\n    line-height: 23px;\n  }\n}\n\n.cursorDefault {\n  cursor: default;\n}\n.smiliesCss {\n  padding-top: 5px;\n  width: 80px;\n  text-align: center;\n}\n.smiliesCss.active {\n  border: #2a874e 1px solid;\n}\n\n.home-top-box-view {\n  margin-top: 100px;\n}\n\n.data-providers-page header {\n  display: flex;\n  align-items: center;\n  margin-bottom: -75px;\n  z-index: 999;\n  position: relative;\n  background: #fff;\n  border-radius: 15px;\n  padding: 30px;\n}\n.data-providers-page header .item {\n  width: 50%;\n}\n.data-providers-page header h1 {\n  font-size: 30px;\n  color: #1995ff;\n  font-weight: 500;\n}\n.data-providers-page header p {\n  font-size: 16px;\n  color: #7b7b7b;\n  font-weight: 400;\n}\n.data-providers-page .main-content {\n  background-image: url(../images/img-37.jpg);\n  background-position: 50% -227.2px;\n  width: 100%;\n  position: relative;\n  background-color: #ccc;\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.data-providers-page .main-content h1 {\n  font-size: 20px;\n  color: #ffffff;\n  font-weight: 500;\n}\n.data-providers-page .main-content p {\n  font-size: 15px;\n  color: #a2a2a2;\n  font-weight: 400;\n  margin-bottom: 0px;\n}\n.data-providers-page .overlay-colored {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.4);\n  z-index: 1;\n}\n.data-providers-page .section-content {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  padding: 120px 0;\n  z-index: 1;\n  background-attachment: fixed;\n  background-position: top center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.data-providers-page .section-content .item {\n  width: 75%;\n  margin: auto;\n  position: relative;\n  margin-bottom: 40px;\n}\n.data-providers-page .section-content .item::after {\n  position: absolute;\n  width: 80%;\n  background: red;\n  height: 2px;\n  content: \"\";\n  border: 0;\n  height: 1px;\n  background: #a2a2a2;\n  background-image: -webkit-linear-gradient(left, #1e1e1e, #a2a2a2, #1e1e1e);\n  background-image: -moz-linear-gradient(left, #ccc, #333, #ccc);\n  background-image: -ms-linear-gradient(left, #ccc, #333, #ccc);\n  background-image: -o-linear-gradient(left, #ccc, #333, #ccc);\n  width: 80%;\n  margin: auto;\n  left: 0px;\n  right: 0px;\n  bottom: -20px;\n}\n.data-providers-page .section-content .item:last-child::after {\n  display: none;\n}\n\n@media (max-width: 767px) {\n  .data-providers-page header {\n    flex-direction: column-reverse;\n  }\n  .data-providers-page header .item {\n    width: 100%;\n  }\n  .data-providers-page .section-content .item {\n    width: 85%;\n  }\n  .data-providers-page .main-content p {\n    /* text-align:justify; */\n  }\n}\n\n/* =================\n    drag and Drop styles\n==================== */\n\n.fixed-top nav.navbar a.ant-dropdown-link {\n  font-size: 20px;\n  margin-right: 20px;\n  margin-left: 20px;\n  color: #c6c6c6;\n  cursor: pointer;\n}\na.ant-dropdown-link span.anticon.anticon-down {\n  display: none;\n}\n\n.ant-dropdown.ant-dropdown-placement-bottomRight {\n  min-width: 200px !important;\n  --arrow-x: 0 !important;\n  --arrow-y: 0px !important;\n  right: 0px !important;\n  left: auto !important;\n}\n\ndiv.ant-dropdown-placement-bottomRight .ant-dropdown-menu {\n  margin-top: 9px;\n  border-radius: 0;\n  min-width: 200px;\n}\ndiv.ant-dropdown-placement-bottomRight .ant-dropdown-menu li {\n  margin: 0 !important;\n  padding: 0 !important;\n}\ndiv.ant-dropdown-placement-bottomRight .ant-dropdown-menu li a {\n  font-size: 16px;\n\n  padding: 8px 20px;\n  font-weight: 500;\n  color: #333333 !important;\n  display: block;\n}\n\ndiv.ant-dropdown-placement-bottomRight .ant-dropdown-menu li a:hover {\n  background: #000000;\n  color: #ffffff !important;\n}\n\n.fixed-top nav.navbar div.relonav-nav-custom-dropdown {\n  margin: 0;\n  padding: 0;\n  margin-top: 15px;\n  border: 0;\n  width: 100%;\n  border-radius: 0;\n}\n.fixed-top nav.navbar div.relonav-nav-custom-dropdown ul {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n}\n.fixed-top nav.navbar div.relonav-nav-custom-dropdown ul li a {\n  font-size: 16px;\n\n  padding: 10px 0px;\n  padding-left: 30px;\n  font-weight: 500;\n  color: #333333;\n  display: block;\n}\n.fixed-top nav.navbar div.relonav-nav-custom-dropdown ul li a:hover {\n  background: #1dabf5;\n  color: #ffffff;\n}\n\n.reloHome {\n  font-family: \"Roboto\", sans-serif;\n  .dssolonavbar.navbar {\n    background: #ffffff;\n    border: 0;\n    box-shadow: 0px 3px 7px #ebebeb !important;\n  }\n  .dssolonavbar.navbar .navbar-nav .nav-link:after {\n    background: #000000;\n  }\n  .dssolonavbar.navbar .navbar-nav .nav-link {\n    color: #000000;\n  }\n  .bg-relo {\n    background: #f3f3f3;\n  }\n  .btn {\n    background: #d9cafa;\n    color: #000000;\n    font-weight: 600;\n    font-size: 17px;\n    font-family: system-ui;\n    /* / letter-spacing: 1px; / */\n    border-radius: 5px;\n    &.btn-2 {\n      background: #ffffff;\n      border: 1px solid #000000;\n    }\n  }\n  h1 {\n    font-size: 40px;\n    font-weight: 700;\n    span {\n      font-size: 40px;\n      font-weight: 700;\n      display: block;\n    }\n    margin-bottom: 30px;\n  }\n\n  h2 {\n    font-size: 33px;\n    font-weight: 700;\n    margin-bottom: 15px;\n  }\n  p {\n  }\n\n  .bannetTextView {\n    min-height: 60vh;\n    display: flex;\n    flex-direction: column;\n    justify-content: end;\n    width: 450px;\n    padding-bottom: 50px;\n  }\n  .tials {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    grid-gap: 50px;\n    width: 95%;\n    max-width: 1000px;\n    margin: 50px auto;\n    &.slider {\n      max-width: initial;\n      width: auto;\n      display: block;\n      a {\n        color: #000000;\n        font-size: 30px;\n        justify-content: end;\n      }\n      p {\n        height: 70px;\n        overflow: hidden;\n      }\n      .box {\n        height: 450px;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n      }\n      .owl-buttons {\n        margin-top: 25px;\n        button {\n          width: 40px;\n          height: 40px;\n          background: #cccccc;\n          border-radius: 50%;\n          border: 0;\n          display: inline-flex;\n          align-items: center;\n          justify-content: center;\n          font-size: 20px;\n          color: #333333;\n          margin-left: 20px;\n          &.owl-prev {\n          }\n          &.owl-next {\n          }\n        }\n      }\n    }\n    .active.center {\n      transform: scale(1);\n      -webkit-filter: grayscale(0); /* Safari 6.0 - 9.0 */\n      filter: grayscale(0);\n\n      .box {\n        background: #d9cafa;\n      }\n      p {\n        height: 100%;\n        overflow: visible;\n      }\n      .fa-circle-plus:before {\n        content: \"\\f057\";\n      }\n    }\n\n    .box {\n      background: #ffffff;\n      padding: 25px;\n      border-radius: 10px;\n      text-align: left;\n      img {\n        width: 40px;\n        margin-bottom: 20px;\n        min-height: 60px;\n      }\n      h3 {\n        font-size: 22px;\n        font-weight: 600;\n      }\n      a {\n        padding-top: 20px;\n        text-decoration: none;\n        display: flex;\n        align-items: center;\n      }\n    }\n  }\n  @media (max-width: 991px) {\n    .dssolonavbar.navbar .navbar-toggler {\n      border: 2px solid #000000;\n    }\n    .dssolonavbar.navbar .navbar-toggler-icon .svg-inline--fa {\n      color: #000000;\n    }\n  }\n  @media (max-width: 767px) {\n    h1 {\n      font-size: 30px;\n      span {\n        font-size: 30px;\n      }\n    }\n    h2 {\n      font-size: 25px;\n    }\n    .bannetTextView {\n      width: 90%;\n    }\n    .tials {\n      grid-template-columns: repeat(1, 1fr);\n      max-width: 400px;\n    }\n    .navbar-brand img {\n      width: 100%;\n    }\n    .navbar-brand span.main-logo-text {\n      padding: 0;\n    }\n  }\n}\n\n@media (max-width: 767px) {\n  .carousel-inner .carousel-item > div {\n    display: none;\n  }\n  .carousel-inner .carousel-item > div:first-child {\n    display: block;\n  }\n}\n\n.carousel-inner .carousel-item.active,\n.carousel-inner .carousel-item-next,\n.carousel-inner .carousel-item-prev {\n  display: flex;\n}\n\n/* / medium and up screens / */\n@media (min-width: 768px) {\n  .carousel-inner .carousel-item-end.active,\n  .carousel-inner .carousel-item-next {\n    transform: translateX(25%);\n  }\n\n  .carousel-inner .carousel-item-start.active,\n  .carousel-inner .carousel-item-prev {\n    transform: translateX(-25%);\n  }\n}\n\n.carousel-inner .carousel-item-end,\n.carousel-inner .carousel-item-start {\n  transform: translateX(0);\n}\n\n/* adapted from  https://codepen.io/glebkema/pen/Xjryjd*/\n\n.owl-item > div:after {\n  font-family: sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n}\n\n#NonTAModalMovingTips {\n  .modal-body {\n    .tails-row {\n      column-count: 2;\n      display: block;\n    }\n  }\n  @media (max-width: 991px) {\n    .modal-body {\n      .tails-row {\n        column-count: 1;\n      }\n    }\n  }\n}\n\n#NonTAPackingRecommendations {\n  .tails-row {\n    column-count: 2;\n    display: block;\n    .tails {\n      margin-bottom: 30px;\n      page-break-inside: avoid;\n    }\n  }\n\n  @media (max-width: 991px) {\n    .tails-row {\n      column-count: 1;\n    }\n  }\n}\n\n.new-r-n-h {\n  font-family: \"Cabinet Grotesk\";\n  background: rgba(246, 246, 246, 1);\n  padding-top: 25px;\n  .navbar li {\n    position: relative;\n  }\n  .navbar .nav-link {\n    padding-right: 25px !important;\n    padding-left: 25px !important;\n  }\n  .navbar li.parent:before {\n    content: \"\\f107\";\n    z-index: 200;\n    position: absolute;\n    top: 50%;\n    right: 5px;\n    transition: margin-top 0.1s ease-out;\n    font-family: \"Font Awesome 6 Pro\";\n    color: #ffffff;\n    transform: translatey(-40%);\n  }\n\n  .navbar li:hover .children,\n  .navbar li:focus .children {\n    opacity: 1;\n    transform: rotateX(0) translateZ(0);\n  }\n  .navbar .children {\n    opacity: 0;\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    transform: rotateX(-90deg);\n    transform-style: preserve-3d;\n    transform-origin: top center;\n    transition: transform 0.4s cubic-bezier(0.17, 0.67, 0.59, 1.21),\n      opacity 0.1s 0.1s;\n    z-index: 100;\n    list-style-type: none;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 200px;\n    padding: 15px;\n    background-color: #fff;\n    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.1);\n    text-align: left;\n    margin-top: 8px;\n    border-radius: 7px;\n  }\n  .navbar .children li {\n    float: none;\n    &:last-child {\n      a {\n        border: 0;\n        margin: 0;\n        padding: 0;\n      }\n    }\n  }\n  .navbar .children a {\n    text-decoration: none;\n    color: #333333;\n    font-weight: 500;\n    border-bottom: 1px solid #ebebeb;\n    display: block;\n    padding-bottom: 5px;\n    margin-bottom: 5px;\n  }\n  .btn {\n    background: #d7c7fa;\n    font-size: 15px;\n    font-weight: 600;\n    padding: 6px 20px;\n    border-radius: 5px;\n    color: #000000;\n    border: 2px solid #d7c7fa;\n    border-radius: 40px;\n    &:hover {\n      background: #000000;\n      color: #d7c7fa;\n    }\n    &.btn-black {\n      background: #000000;\n      color: #ffffff;\n      border-color: #000000;\n      &:hover {\n        background: #ffffff;\n        color: #000000;\n      }\n    }\n  }\n  h1 {\n    font-size: 50px;\n    font-weight: 800;\n  }\n  h2 {\n    font-size: 35px;\n    font-weight: 800;\n    /* border-color: red; */\n    span.h2-span {\n      font-size: 25px;\n      display: block;\n    }\n  }\n  p {\n  }\n  form.width {\n    width: 200px;\n    text-align: right;\n  }\n  .bannerPart {\n    background-image: url(../publicImages/bannerBg.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n    height: 90vh;\n    width: 100%;\n    padding: 100px 0;\n\n    .view {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      grid-column-gap: 30px;\n      .box-1 {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: flex-start;\n      }\n\n      .box {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        grid-template-rows: 300px 300px;\n        grid-gap: 20px;\n        .items {\n          border-radius: 8px;\n          overflow: hidden;\n          img {\n            height: 100%;\n            object-fit: cover;\n          }\n        }\n        .items:nth-child(1) {\n          grid-column: 1;\n        }\n        .items:nth-child(2) {\n          grid-column: 1;\n        }\n        .items:nth-child(3) {\n          grid-column: 2 / span 3;\n          grid-row: 1 / span 2;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          flex-direction: column;\n          img {\n            height: auto;\n          }\n        }\n      }\n    }\n    padding: 50px 0;\n  }\n\n  .tials {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    grid-gap: 35px;\n    margin: 35px auto 50px;\n    .box {\n      background: #ffffff;\n      padding: 40px;\n      border-radius: 28px;\n      text-align: left;\n\n      img {\n        margin-bottom: 20px;\n        filter: brightness(0);\n      }\n      h3 {\n        font-size: 22px;\n        font-weight: 600;\n        /* text-transform: uppercase; */\n        margin-bottom: 20px;\n      }\n    }\n  }\n  .box-image {\n    background-image: url(../publicImages/side-bg.svg);\n    background-repeat: no-repeat;\n    height: 100%;\n    /* width: 100%; */\n    min-height: 600px;\n    background-size: cover;\n    /* background-position: 0px 0; */\n  }\n  ul#myTab {\n    border: 0;\n    justify-content: center;\n    background: #ffffff;\n    box-shadow: 2px 4px 26.5px 0px #0000000d;\n    width: 670px;\n    margin: auto;\n    padding: 15px 0px 15px 0px;\n    border-radius: 100px;\n    gap: 80px;\n    margin-bottom: 35px;\n    .nav-link {\n      background: transparent !important;\n      color: #000000;\n      border: 0;\n      font-weight: 600;\n      font-size: 17px;\n      border-radius: 55px;\n      padding: 12px 24px;\n      &.active {\n        background: #d7c7fa !important;\n      }\n    }\n  }\n  .grid-box {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    grid-gap: 25px;\n    padding-bottom: 50px;\n    .items {\n      h4 {\n        position: relative;\n        font-size: 40px;\n        font-weight: 800;\n        span {\n          display: block;\n          font-size: 16px;\n          text-transform: uppercase;\n          margin-bottom: 10px;\n          font-weight: 500;\n        }\n      }\n      h3 {\n        position: relative;\n        font-size: 30px;\n        font-weight: 800;\n        span {\n          display: block;\n          font-size: 16px;\n          font-weight: 500;\n          text-transform: uppercase;\n          margin-bottom: 10px;\n        }\n      }\n      P {\n        position: relative;\n        font-size: 18px;\n        font-weight: 500;\n      }\n      .tail {\n        border-radius: 28px;\n        overflow: hidden;\n        position: relative;\n        min-height: 450px;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        padding: 30px;\n        background: #000000;\n        &.tailHeight {\n          min-height: 440px;\n        }\n        img {\n          position: absolute;\n          bottom: 0;\n          width: 100%;\n          left: 0px;\n          top: 0px;\n          right: 0px;\n          height: 100%;\n          object-fit: cover;\n          &.report {\n            width: 100% !important;\n            height: auto !important;\n            opacity: 0.4 !important;\n          }\n          &.right {\n            right: 0;\n            left: auto;\n            &.report {\n              width: 50% !important;\n            }\n          }\n        }\n      }\n\n      &.full {\n        .tail {\n          img {\n            /* position: static; */\n            height: 100%;\n            width: 100%;\n            object-fit: cover;\n            opacity: 1;\n          }\n          height: 100%;\n        }\n      }\n\n      height: 100%;\n    }\n\n    .subTail {\n      background: #ffffff;\n      border-radius: 28px;\n      overflow: hidden;\n      padding: 20px;\n      min-height: 250px;\n      h3 {\n        margin-bottom: 5px;\n        font-size: 24px;\n        font-weight: 800;\n        color: #000000;\n        text-transform: uppercase;\n      }\n    }\n  }\n\n  #individuals-tab-pane {\n    .grid-box {\n      .items {\n        &.full {\n          display: flex;\n          flex-direction: column;\n        }\n        &.widthFull {\n          grid-column: 2 / span 3;\n          grid-gap: 25px;\n          display: grid;\n        }\n        .fs-7 {\n          font-size: 14px !important;\n        }\n\n        .boxView {\n          display: grid;\n          grid-template-columns: repeat(3, 1fr);\n          grid-gap: 25px;\n          .box-tail {\n            border-radius: 30px;\n            position: relative;\n            overflow: hidden;\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n            padding: 25px;\n            min-height: 170px;\n            box-shadow: 2px 0px 26.5px 5px #0000000d;\n            color: #ffffff;\n            background: #ffffff;\n            p {\n              font-size: 13px;\n            }\n            &.full {\n              grid-column: 2 / span 3;\n              grid-row: 1 / span 2;\n              min-height: 300px;\n\n              h2 {\n                font-size: 38px;\n                padding-right: 20px;\n                font-weight: 800;\n                position: relative;\n                span {\n                  display: block;\n                  font-size: 16px;\n                  font-weight: 500;\n                  text-transform: uppercase;\n                  margin-bottom: 10px;\n                }\n              }\n              p {\n                font-size: 18px;\n              }\n            }\n            img {\n              position: absolute;\n              top: 0px;\n              left: 0px;\n              bottom: 0px;\n              right: 0px;\n              width: 100%;\n              height: 100%;\n              object-fit: cover;\n            }\n\n            &:nth-child(1) {\n              h3 {\n                position: absolute;\n                font-size: 22px;\n                bottom: 15px;\n                left: 0px;\n                right: 0px;\n                text-align: center;\n              }\n            }\n\n            &:nth-child(3) {\n              h3 {\n                font-size: 28px;\n              }\n            }\n          }\n          &.boxView-2 {\n            grid-template-columns: 65% 35%;\n            grid-gap: 25px;\n            width: calc(100% - 25px);\n\n            .box-tail {\n              display: block;\n\n              &.full {\n                grid-row: 1 / span 2;\n                grid-column: initial;\n                display: flex;\n              }\n              img.static {\n                position: static;\n                height: auto;\n                width: auto;\n              }\n              h3 {\n                font-size: 24px;\n              }\n              p {\n                font-size: 17px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  #companies-tab-pane {\n    .final-box {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      grid-gap: 25px;\n      .tail {\n        border-radius: 28px;\n        overflow: hidden;\n        position: relative;\n        min-height: 400px;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        padding: 30px;\n        background: #000000;\n        img {\n          position: absolute;\n          bottom: 0;\n          width: 100%;\n          left: 0px;\n          top: 0px;\n          right: 0px;\n          height: 100%;\n          width: 100%;\n          object-fit: cover;\n          opacity: 1;\n        }\n        h3 {\n          font-size: 40px;\n          font-weight: 800;\n          span {\n            display: block;\n            font-size: 20px;\n            font-weight: 500;\n            text-transform: uppercase;\n            margin-bottom: 10px;\n          }\n        }\n        p {\n          font-size: 18px;\n          font-weight: 500;\n        }\n      }\n    }\n  }\n\n  ul.tickList {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n    li {\n      font-size: 18px;\n      background: url(../publicImages/tick.png);\n      span {\n        display: block;\n        font-size: 22px;\n        font-weight: 700;\n      }\n      background-repeat: no-repeat;\n      background-position: 0 5px;\n      padding-left: 45px;\n      font-weight: 500;\n      padding-bottom: 25px;\n    }\n    /* display: flex; */\n    /* align-items: center; */\n  }\n  .accrodianView {\n    background: #000000;\n    border-radius: 10px;\n    overflow: hidden;\n\n    .accordion {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      height: 100%;\n      padding: 40px;\n      .accordion-button::after {\n        display: none;\n      }\n      .accordion-item {\n        background: #000000;\n        .accordion-button {\n          color: #ffffff;\n          background: transparent;\n          /* border-color: red; */\n          border: 1px solid #cccccc;\n          margin-bottom: 0;\n          box-shadow: none;\n          border-radius: 7px;\n        }\n        border-color: #3a3a3a;\n        border: 0;\n        margin-bottom: 15px;\n      }\n      .accordion-body {\n        background: #ffffff;\n        text-align: left;\n        margin: 15px 0 0;\n        border-radius: 7px;\n      }\n    }\n    h5 {\n      font-weight: 800;\n    }\n    p {\n      font-weight: 500;\n    }\n    &.for-companies {\n      background: transparent;\n      .accordion {\n        padding: 20px;\n        .accordion-item {\n          background: transparent;\n          border-bottom: 2px solid #cccccc;\n          border-radius: 0;\n          margin: 0;\n          &:has(.collapse.show) {\n            border-color: #000000;\n          }\n          .accordion-body {\n            background: transparent;\n            padding: 0;\n            margin-left: 55px;\n            margin-top: 10px;\n            margin-bottom: 20px;\n          }\n          .accordion-button {\n            color: #000000;\n            background: transparent;\n            border: 0;\n            margin-bottom: 0;\n            box-shadow: none;\n            border-radius: 0;\n            padding: 20px 0px 0px 0px;\n            font-weight: 700;\n            font-size: 23px;\n            img {\n              margin-right: 20px;\n            }\n            &.collapsed {\n              border-color: #cccccc;\n              padding: 20px 0;\n            }\n          }\n        }\n      }\n    }\n  }\n  .footer {\n    background-image: url(../publicImages/footer-bg.png);\n    background-repeat: no-repeat;\n    padding-bottom: 100px;\n    background-size: 100%;\n    min-height: 600px;\n    height: 100%;\n    position: relative;\n    background-color: #000000;\n    .spacing {\n      height: 200px;\n    }\n    h4 {\n      color: #ffffff;\n      margin-bottom: 20px;\n    }\n    .logo {\n      width: 100%;\n      max-width: 300px;\n    }\n    ul {\n      list-style-type: none;\n      &.social {\n        display: flex;\n        li {\n          margin-right: 20px;\n          a {\n            opacity: 0.5;\n          }\n        }\n      }\n      li {\n        a {\n          color: rgba(255, 255, 255, 0.5);\n          text-decoration: none;\n          font-size: 20px;\n          margin-bottom: 5px;\n          display: block;\n        }\n      }\n      margin: 0;\n      padding: 0;\n    }\n    .gridView {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      text-align: left;\n    }\n    background-color: #000000;\n  }\n\n  div#signUpModal {\n    .modal-content {\n      background: #f3f3f3;\n      h2 {\n        font-weight: 800;\n        text-align: center;\n      }\n      p {\n        a {\n          color: rgba(45, 116, 255, 1);\n          text-decoration: none;\n          font-weight: 700;\n          padding-left: 5px;\n        }\n        font-size: 22px;\n        font-weight: 500;\n        text-align: center;\n        color: #000000;\n      }\n      label {\n        font-size: 23px;\n        color: #000000;\n        font-weight: 600;\n        &.form-check-label {\n          font-size: 18px;\n        }\n      }\n      .form-check + a {\n        font-size: 18px;\n        font-weight: 600;\n        text-decoration: none;\n      }\n      input.form-control {\n        height: 60px;\n        padding: 20px;\n        font-size: 20px;\n        border-radius: 6px;\n      }\n      form {\n        width: 80%;\n        margin: auto;\n        padding-bottom: 30px;\n      }\n      .btn {\n        height: 50px;\n        width: 100%;\n        font-size: 20px;\n        font-weight: 500;\n        /* margin: 20px 0; */\n        &.btn-google {\n          background: #fff;\n          border-radius: 7px;\n          border: 1px solid #ccc;\n          &:hover {\n            background: #000000;\n          }\n        }\n      }\n    }\n  }\n  .contactUs {\n    padding-top: 110px;\n    height: auto;\n    h2 {\n      font-size: 70px;\n      font-weight: 800;\n    }\n    ul {\n      list-style-type: none;\n      padding: 0;\n      margin-top: 45px;\n      li {\n        font-size: 17px;\n        margin-bottom: 15px;\n        font-weight: 500;\n        span {\n          display: block;\n          font-weight: 800;\n          font-size: 18px;\n          margin-bottom: 5px;\n        }\n        ul {\n          display: flex;\n          margin: 0;\n          margin-top: 10px;\n          li {\n            margin-right: 10px;\n            img {\n              width: 25px;\n            }\n          }\n        }\n      }\n    }\n    .form {\n      background: #ffffff;\n      border-radius: 12px;\n      box-shadow: 0px 0px 10px #cccccc;\n      padding: 30px;\n      label {\n        font-size: 18px;\n        font-weight: 600;\n      }\n      input.form-control {\n        height: 46px;\n        border-radius: 7px;\n        /* font-weight: 500; */\n        font-size: 16px;\n      }\n    }\n  }\n\n  .view.bg-imageView {\n    background: #0a0a0a;\n  }\n\n  .bannerPart.innerPage {\n    height: 40vh;\n    min-height: 450px;\n  }\n\n  .sr-box-tails {\n    max-width: 900px;\n    margin: auto;\n    margin-top: 5rem;\n    .items {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 50px;\n      margin-bottom: 4rem;\n      h3 {\n        color: #ffffff;\n        font-weight: 800;\n        margin-bottom: 10px;\n        span {\n          display: block;\n          font-size: 1.1rem;\n          font-weight: 400;\n          margin-bottom: 10px;\n        }\n      }\n      p {\n        color: #ffffff;\n        font-size: 1rem;\n        font-weight: 400;\n      }\n      img {\n        max-width: 400px;\n        width: 100%;\n      }\n    }\n  }\n\n  .choose-tails.tials {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 45px;\n    .box {\n      width: 30%;\n    }\n    h3 {\n      font-size: 28px;\n    }\n  }\n\n  .forsubText {\n    grid-template-columns: 45% 65%;\n    grid-gap: 50px;\n    text-align: left;\n  }\n  .for-companies-tails {\n    grid-template-columns: repeat(3, 1fr);\n    grid-gap: 30px;\n  }\n  .for-companies-calendar {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-columns: 40% 60%;\n    grid-gap: 30px;\n\n    .box {\n      &.textView {\n        background: #000000;\n        color: #ffffff;\n        padding: 50px;\n        border-radius: 13px;\n      }\n      &.imageView {\n        position: relative;\n        background: #ffffff;\n        border-radius: 13px;\n        padding: 50px;\n        img {\n          position: absolute;\n          top: 15px;\n          left: 0;\n          width: 100%;\n        }\n      }\n    }\n    p {\n      margin-bottom: 30px;\n    }\n    ul {\n      padding: 0;\n      li {\n        margin-left: 40px;\n        list-style-type: disc;\n        margin-bottom: 10px;\n      }\n    }\n    &:last-child {\n      grid-template-columns: 60% 40%;\n      .box {\n        &.textView {\n          background: #000000;\n          color: #ffffff;\n          padding: 50px;\n          border-radius: 13px;\n        }\n        &.imageView {\n          position: relative;\n          background: #ffffff;\n          border-radius: 13px;\n          padding: 0px;\n          overflow: hidden;\n          .imgBg {\n            background: url(../publicImages/forcompany/for-companies-6-bg.png);\n            background-repeat: no-repeat;\n            height: 100%;\n            padding: 70px;\n            display: flex;\n            align-items: flex-end;\n            padding-bottom: 0;\n          }\n          img {\n            position: static;\n          }\n        }\n      }\n    }\n  }\n\n  .for-companiesWhyCHoose {\n    grid-template-columns: repeat(2, 1fr);\n    grid-gap: 25px;\n    .box {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      grid-gap: 25px;\n      .item {\n        background: #d7d7d7;\n        border-radius: 5px;\n        padding: 25px;\n\n        img {\n          width: 35px;\n          margin-bottom: 20px;\n        }\n        h4 {\n          font-weight: 700;\n        }\n        p {\n          font-size: 16px;\n          margin: 0;\n        }\n      }\n    }\n  }\n\n  .for-companiesImageTextView {\n    position: relative;\n    text-align: center;\n    img {\n      max-width: 1000px;\n      margin: auto;\n    }\n    h6 {\n      background: #f5f1ff;\n      box-shadow: 2px 6px 10px 0px #0000001a;\n      width: 450px;\n      border-radius: 10px;\n      padding: 20px;\n      color: #000000;\n      position: absolute;\n      top: 60px;\n      right: 0px;\n      &:nth-child(2) {\n        right: auto;\n        top: 50%;\n        transform: translateY(-50%);\n      }\n      &:nth-child(3) {\n        bottom: -40px;\n        top: auto;\n        left: 40%;\n      }\n      span {\n        display: block;\n        position: relative;\n        font-weight: 700;\n        font-size: 16px;\n        padding-left: 16px;\n        text-align: left;\n        &::after {\n          content: \"\";\n          position: absolute;\n          left: 0px;\n          top: 0px;\n          bottom: 0px;\n          height: 100%;\n          width: 6px;\n          background: #9b70fb;\n          border-radius: 10px;\n        }\n      }\n    }\n  }\n\n  .tials.for-companiesTails {\n    .box {\n      background: transparent;\n      padding: 40px;\n      border-radius: 10px;\n      text-align: left;\n\n      &.active,\n      &:hover {\n        background: #ffffff;\n        box-shadow: 0px 11px 18.4px 0px #0000001a;\n      }\n      a {\n        font-size: 16px;\n        font-weight: 700;\n        text-decoration: none;\n        color: #000000;\n      }\n    }\n  }\n  .relo-activities-section {\n    position: relative;\n    .card-view {\n      .item {\n        position: relative;\n        padding: 25px;\n        padding-left: 45px;\n        margin-bottom: 15px;\n        border-radius: 10px;\n        max-width: 500px;\n        h3 {\n          font-size: 20px;\n          font-weight: 700;\n        }\n        p {\n          font-size: 16px;\n        }\n        a {\n          color: #9b70fb;\n          font-weight: 800;\n          text-decoration: none;\n          visibility: hidden;\n        }\n        &.active,\n        &:hover {\n          background: #f5f1ff;\n          box-shadow: 0px 7px 20.9px 0px #0000001a;\n\n          &::after {\n            content: \"\";\n            position: absolute;\n            left: 20px;\n            top: 25px;\n            width: 8px;\n            bottom: 25px;\n            background: #9b70fb;\n            border-radius: 10px;\n          }\n          a {\n            visibility: visible;\n          }\n        }\n      }\n    }\n    .laptop-image {\n      position: absolute;\n      right: 0px;\n      width: 50%;\n      top: 0;\n      height: 100%;\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n  }\n\n  .for-companies-slider {\n    padding: 50px 80px;\n    .vSlider .l-realise-slider-card-block {\n      position: relative;\n      margin-left: 0px;\n      display: flex;\n      justify-content: center;\n    }\n\n    .vSlider .card {\n      position: absolute;\n      display: block;\n      width: 400px;\n      height: auto;\n      -webkit-transition: all 0.4s;\n      transition: all 0.4s;\n      border-radius: 15px;\n      box-shadow: 0px 10px 20px #080808;\n      background: #f9f9f9;\n    }\n\n    .vSlider .card.c {\n      -webkit-transform: translate3d(0px, 20px, 0px) scaleX(0.9);\n      transform: translate3d(0px, 20px, 0px) scaleX(0.9);\n      z-index: 9;\n    }\n\n    .vSlider .card.b {\n      -webkit-transform: translate3d(0px, 40px, 0px) scaleX(0.8);\n      transform: translate3d(0px, 40px, 0px) scaleX(0.8);\n      z-index: 1;\n    }\n\n    .vSlider .card.a {\n      -webkit-transform: translate3d(0px, 0px, 0px) scaleX(1);\n      transform: translate3d(0px, 0px, 0px) scaleX(1);\n      z-index: 99;\n    }\n\n    .vSlider {\n      height: 500px;\n    }\n\n    /* Basic styling for the slider and cards */\n    .vSlider {\n      margin: 0px auto 30px;\n      width: 100%;\n      text-align: center;\n    }\n\n    .card {\n      display: inline-block;\n      width: 200px;\n      height: 200px;\n      margin: 20px;\n      background-color: #f4f4f4;\n      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    }\n\n\n    .card-text {\n      position: absolute;\n      top: 0px;\n      left: 0px;\n      width: 100%;\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      padding: 32px;\n      text-align: left;\n    }\n    .card-text h4 {\n    font-size: 43px;\n    font-weight: 800;\n    text-transform: uppercase;\n    margin-top: 13px;\n    }\n  p{\n    margin-bottom: 10px;\n    font-size: 16px;\n    font-weight: 700;\n    color: #000000;\n  }\n    .card img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    /* Dots styling */\n    .slider-dots {\n      text-align: center;\n      margin-top: 20px;\n    }\n\n    .dot {\n      display: inline-block;\n      width: 25px;\n      height: 5px;\n      margin: 0 5px;\n      background-color: #ddd;\n      border-radius: 2px;\n      cursor: pointer;\n      transition: background-color 0.3s ease;\n    }\n\n    .dot.active {\n      background-color: #9f77f8;\n    }\n\n    .dot:hover {\n      background-color: #9f77f8;\n    }\n  }\n  .YourTeamSection {\n    position: relative;\n    border-radius: 10px;\n    overflow: hidden;\n    img {\n      width: 100%;\n    }\n    .teamText {\n      position: absolute;\n      top: 0px;\n      bottom: 0;\n      left: 0px;\n      right: 0px;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      max-width: 700px;\n      width: 80%;\n      margin: auto;\n      color: #ffffff;\n      text-align: center;\n      h4 {\n        font-size: 38px;\n        font-weight: 700;\n      }\n    }\n  }\n\n  .my-6rem{\n    margin-top: 6rem !important;\n    margin-bottom: 6rem !important;\n  }\n  .mt-6rem{\n    margin-top: 6rem !important;\n  }\n  .mb-6rem{\n    margin-bottom: 6rem !important;\n  }\n  .py-6rem{\n    padding-top: 6rem !important;\n    padding-bottom: 6rem !important;\n  }\n  @media (max-width: 1399px) {\n    & .grid-box {\n      & .items {\n        & .tail {\n          min-height: 400px;\n          &.tailHeight {\n            min-height: 400px;\n          }\n        }\n      }\n    }\n  }\n\n  @media (max-width: 1199px) {\n    h1 {\n      font-size: 45px;\n    }\n    & .grid-box {\n      & .items {\n        h4 {\n          font-size: 25px;\n        }\n        h3 {\n          font-size: 22px;\n        }\n      }\n    }\n\n    & .grid-box {\n      & .items {\n        .tail {\n          min-height: 370px;\n          &.tailHeight {\n            min-height: 334px;\n          }\n        }\n      }\n    }\n    & #individuals-tab-pane {\n      & .grid-box {\n        & .items {\n          & .boxView {\n            & .box-tail {\n              padding: 15px;\n              p {\n                font-size: 12px;\n              }\n            }\n          }\n        }\n      }\n    }\n    .navbar .nav-link {\n      padding-right: 15px !important;\n      padding-left: 10px !important;\n    }\n    .navbar li.parent:before {\n      right: -5px;\n    }\n    form.width {\n      width: 180px;\n    }\n    .forsubText {\n      grid-template-columns: repeat(2, 1fr);\n    }\n    .for-companies-calendar {\n      p {\n        font-size: 14px;\n        margin-bottom: 15px;\n      }\n      h3 {\n        font-weight: 700;\n        font-size: 25px;\n      }\n      li {\n        font-size: 14px;\n      }\n    }\n    .for-companiesImageTextView {\n      img {\n        max-width: 800px;\n        margin: auto;\n      }\n    }\n  } /*1199px - end*/\n  @media (max-width: 991px) {\n    & .bannerPart {\n      height: auto;\n      .view {\n        grid-template-columns: repeat(1, 1fr);\n        .box {\n          margin-top: 50px;\n        }\n      }\n    }\n    & .grid-box {\n      grid-template-columns: repeat(1, 1fr);\n\n      & .items {\n        .tail {\n          min-height: 350px;\n        }\n\n        &.full {\n          height: calc(100% - 20px);\n        }\n      }\n    }\n    .tials {\n      grid-template-columns: repeat(1, 1fr);\n    }\n    .box-image {\n      min-height: 400px;\n    }\n    form.width {\n      text-align: left;\n    }\n    .contactUs {\n      padding-top: 50px;\n    }\n\n    & #individuals-tab-pane {\n      & .grid-box {\n        & .items {\n          &.widthFull {\n            display: block;\n            grid-column: initial;\n          }\n          & .boxView {\n            grid-template-columns: repeat(1, 1fr);\n            & .box-tail {\n              grid-column: initial !important;\n              grid-row: initial !important;\n            }\n            &.boxView-2 {\n              grid-gap: 25px;\n              grid-template-columns: repeat(1, 1fr);\n              margin-top: 25px;\n            }\n          }\n        }\n      }\n    }\n\n    & #companies-tab-pane {\n      & .final-box {\n        grid-template-columns: repeat(1, 1fr);\n        & .tail {\n          & h3 {\n            font-size: 27px;\n            span {\n              font-size: 18px;\n            }\n          }\n        }\n      }\n    }\n\n    & ul#myTab {\n      gap: 80px;\n      width: 100%;\n      max-width: 700px;\n    }\n    .sr-box-tails {\n      .items {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 30px;\n        flex-direction: column;\n        max-width: 400px;\n        margin: auto;\n        margin-bottom: 35px;\n        padding-bottom: 15px;\n        border-bottom: 1px solid #3c3c3c;\n      }\n    }\n    .choose-tails.tials {\n      gap: 30px;\n      .box {\n        width: 100%;\n      }\n    }\n    .for-companies-calendar {\n      .box {\n        &.imageView {\n          img {\n            position: static;\n          }\n        }\n      }\n      grid-template-columns: repeat(1, 1fr);\n      p {\n        font-size: 16px;\n        margin-bottom: 20px;\n      }\n      h3 {\n        font-weight: 700;\n        font-size: 30px;\n      }\n      li {\n        font-size: 16px;\n      }\n      &:last-child {\n        grid-template-columns: repeat(1, 1fr);\n      }\n    }\n    .for-companiesImageTextView {\n      img {\n        max-width: 600px;\n        margin: auto;\n      }\n      h6 {\n        width: 300px;\n        span {\n          font-size: 11px;\n        }\n      }\n    }\n    .relo-activities-section {\n      .laptop-image {\n          position: static;\n          width: 100%;\n      }\n    }\n    .YourTeamSection {\n      img {\n          width: auto;\n          height: 300px;\n      }\n    }\n  } /*991px-end*/\n  @media (max-width: 767px) {\n    h1 {\n      font-size: 35px;\n    }\n    h2 {\n      font-size: 28px;\n      span.h2-span {\n        font-size: 20px;\n      }\n    }\n\n    .view.bg-imageView {\n      position: relative;\n      .box-item {\n        background: rgba(0, 0, 0, 0.4);\n        position: relative;\n        z-index: 9;\n      }\n      /* z-index: 9; */\n      min-height: 400px;\n      width: 100%;\n      margin: auto;\n    }\n    .box-image {\n      position: absolute;\n    }\n    ul#myTab {\n      flex-wrap: nowrap;\n      gap: 30px;\n      .nav-link {\n        font-size: 16px;\n      }\n    }\n    & div#signUpModal {\n      & .modal-content {\n        form {\n          width: 100%;\n        }\n        padding: 15px !important;\n      }\n    }\n    .for-companiesImageTextView {\n      h6 {\n        width: 300px;\n        top: 0;\n      }\n    }\n    .for-companies-slider {\n      padding: 50px;\n      .vSlider {\n          margin: auto;\n          width: 100%;\n\n      }\n      .vSlider .card{\n        margin: auto;\n        width: 100%;\n      }\n    }\n    .YourTeamSection {\n      .teamText{\n        h4{\n          font-size: 28px;\n         }\n      }\n      \n    }\n  }/*767px-end*/\n  @media (max-width: 576px) {\n    ul#myTab {\n      gap: 20px;\n      flex-direction: column;\n      margin: auto;\n      justify-content: center;\n      align-items: center;\n      border-radius: 30px;\n      padding: 20px;\n      margin-bottom: 25px;\n\n      li {\n        width: 100%;\n      }\n      .nav-link {\n        font-size: 16px;\n        width: 100%;\n      }\n    }\n    .for-companiesWhyCHoose {\n      max-width: 350px;\n      margin: auto;\n      .box {\n        grid-template-columns: repeat(1, 1fr);\n      }\n    }\n    .for-companiesImageTextView {\n      h6 {\n        position: static;\n        transform: initial !important;\n        width: 100%;\n      }\n    }\n  \n  }\n\n  @media (max-width: 450px){\n    .for-companies-slider {\n      .vSlider {\n         height: 400px;\n\n      }\n    \n    }\n     .for-companies-slider {\n      .card-text{\n        padding: 20px;\n        h4 {\n          font-size: 30px;\n          font-weight: 800;\n          margin: 0;\n        }\n        p{\n          font-size: 14px;\n        }\n      }\n    }\n  }\n}\n.city-landing-page.newOne .ulSlider {\n  max-width: 730px;\n  margin: auto;\n  width: 100%;\n}\n\n.demoView {\n  position: relative;\n  div#map {\n    height: 100vh;\n    width: 100%;\n  }\n  .point-tails {\n    position: absolute;\n    z-index: 9;\n    top: 30px;\n    left: 30px;\n    background: #fff;\n    padding: 25px;\n    border-radius: 12px;\n    box-shadow: 0px 0px 10px #838383;\n    max-height: calc(100vh - 60px);\n    overflow: auto;\n\n    h3 {\n      font-size: 16px;\n      padding-bottom: 10px;\n      margin-bottom: 10px;\n      border-bottom: 1px solid #d7d7d7;\n      color: #000000;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
